var map = {
	"./": 97,
	"./bird": 175,
	"./bird-inverted": 176,
	"./bird-inverted.png": 176,
	"./bird.png": 175,
	"./covers/cover-1": 177,
	"./covers/cover-1.jpg": 177,
	"./covers/cover-10": 178,
	"./covers/cover-10.jpg": 178,
	"./covers/cover-11": 179,
	"./covers/cover-11.jpg": 179,
	"./covers/cover-12": 180,
	"./covers/cover-12.jpg": 180,
	"./covers/cover-13": 181,
	"./covers/cover-13.jpg": 181,
	"./covers/cover-14": 182,
	"./covers/cover-14.jpg": 182,
	"./covers/cover-15": 183,
	"./covers/cover-15.jpg": 183,
	"./covers/cover-16": 184,
	"./covers/cover-16.jpg": 184,
	"./covers/cover-17": 185,
	"./covers/cover-17.jpg": 185,
	"./covers/cover-18": 186,
	"./covers/cover-18.jpg": 186,
	"./covers/cover-2": 187,
	"./covers/cover-2.jpg": 187,
	"./covers/cover-3": 188,
	"./covers/cover-3.jpg": 188,
	"./covers/cover-4": 189,
	"./covers/cover-4.jpg": 189,
	"./covers/cover-5": 190,
	"./covers/cover-5.jpg": 190,
	"./covers/cover-6": 191,
	"./covers/cover-6.jpg": 191,
	"./covers/cover-7": 192,
	"./covers/cover-7.jpg": 192,
	"./covers/cover-8": 193,
	"./covers/cover-8.jpg": 193,
	"./covers/cover-9": 194,
	"./covers/cover-9.jpg": 194,
	"./covers/ha-top-bg": 195,
	"./covers/ha-top-bg.jpg": 195,
	"./covers/login-cover": 196,
	"./covers/login-cover.jpg": 196,
	"./discord-logo": 197,
	"./discord-logo.png": 197,
	"./fonts/Feather": 198,
	"./fonts/Feather.svg": 198,
	"./fonts/Feather.ttf": 1290,
	"./fonts/Feather.woff": 1291,
	"./fonts/HKGroteskPro/HKGroteskPro-Bold.otf": 1292,
	"./fonts/HKGroteskPro/HKGroteskPro-Bold.woff": 1293,
	"./fonts/HKGroteskPro/HKGroteskPro-Bold.woff2": 1294,
	"./fonts/HKGroteskPro/HKGroteskPro-BoldItalic.otf": 1295,
	"./fonts/HKGroteskPro/HKGroteskPro-BoldItalic.woff": 1296,
	"./fonts/HKGroteskPro/HKGroteskPro-BoldItalic.woff2": 1297,
	"./fonts/HKGroteskPro/HKGroteskPro-Book.otf": 1298,
	"./fonts/HKGroteskPro/HKGroteskPro-Book.woff": 1299,
	"./fonts/HKGroteskPro/HKGroteskPro-Book.woff2": 1300,
	"./fonts/HKGroteskPro/HKGroteskPro-BookItalic.otf": 1301,
	"./fonts/HKGroteskPro/HKGroteskPro-BookItalic.woff": 1302,
	"./fonts/HKGroteskPro/HKGroteskPro-BookItalic.woff2": 1303,
	"./fonts/HKGroteskPro/HKGroteskPro-ExtraLight.otf": 1304,
	"./fonts/HKGroteskPro/HKGroteskPro-ExtraLight.woff": 1305,
	"./fonts/HKGroteskPro/HKGroteskPro-ExtraLight.woff2": 1306,
	"./fonts/HKGroteskPro/HKGroteskPro-ExtraLightItalic.otf": 1307,
	"./fonts/HKGroteskPro/HKGroteskPro-ExtraLightItalic.woff": 1308,
	"./fonts/HKGroteskPro/HKGroteskPro-ExtraLightItalic.woff2": 1309,
	"./fonts/HKGroteskPro/HKGroteskPro-Hairline.otf": 1310,
	"./fonts/HKGroteskPro/HKGroteskPro-Hairline.woff": 1311,
	"./fonts/HKGroteskPro/HKGroteskPro-Hairline.woff2": 1312,
	"./fonts/HKGroteskPro/HKGroteskPro-HairlineItalic.otf": 1313,
	"./fonts/HKGroteskPro/HKGroteskPro-HairlineItalic.woff": 1314,
	"./fonts/HKGroteskPro/HKGroteskPro-HairlineItalic.woff2": 1315,
	"./fonts/HKGroteskPro/HKGroteskPro-Italic.otf": 1316,
	"./fonts/HKGroteskPro/HKGroteskPro-Italic.woff": 1317,
	"./fonts/HKGroteskPro/HKGroteskPro-Italic.woff2": 1318,
	"./fonts/HKGroteskPro/HKGroteskPro-Light.otf": 1319,
	"./fonts/HKGroteskPro/HKGroteskPro-Light.woff": 1320,
	"./fonts/HKGroteskPro/HKGroteskPro-Light.woff2": 1321,
	"./fonts/HKGroteskPro/HKGroteskPro-LightItalic.otf": 1322,
	"./fonts/HKGroteskPro/HKGroteskPro-LightItalic.woff": 1323,
	"./fonts/HKGroteskPro/HKGroteskPro-LightItalic.woff2": 1324,
	"./fonts/HKGroteskPro/HKGroteskPro-Medium.otf": 1325,
	"./fonts/HKGroteskPro/HKGroteskPro-Medium.woff": 1326,
	"./fonts/HKGroteskPro/HKGroteskPro-Medium.woff2": 1327,
	"./fonts/HKGroteskPro/HKGroteskPro-MediumItalic.otf": 1328,
	"./fonts/HKGroteskPro/HKGroteskPro-MediumItalic.woff": 1329,
	"./fonts/HKGroteskPro/HKGroteskPro-MediumItalic.woff2": 1330,
	"./fonts/HKGroteskPro/HKGroteskPro-Regular.otf": 1331,
	"./fonts/HKGroteskPro/HKGroteskPro-Regular.woff": 1332,
	"./fonts/HKGroteskPro/HKGroteskPro-Regular.woff2": 1333,
	"./fonts/HKGroteskPro/HKGroteskPro-SemiBold.otf": 1334,
	"./fonts/HKGroteskPro/HKGroteskPro-SemiBold.woff": 1335,
	"./fonts/HKGroteskPro/HKGroteskPro-SemiBold.woff2": 1336,
	"./fonts/HKGroteskPro/HKGroteskPro-SemiBoldItalic.otf": 1337,
	"./fonts/HKGroteskPro/HKGroteskPro-SemiBoldItalic.woff": 1338,
	"./fonts/HKGroteskPro/HKGroteskPro-SemiBoldItalic.woff2": 1339,
	"./fonts/HKGroteskPro/HKGroteskPro-Thin.otf": 1340,
	"./fonts/HKGroteskPro/HKGroteskPro-Thin.woff": 1341,
	"./fonts/HKGroteskPro/HKGroteskPro-Thin.woff2": 1342,
	"./fonts/HKGroteskPro/HKGroteskPro-ThinItalic.otf": 1343,
	"./fonts/HKGroteskPro/HKGroteskPro-ThinItalic.woff": 1344,
	"./fonts/HKGroteskPro/HKGroteskPro-ThinItalic.woff2": 1345,
	"./icons/duotone-icons/Clothes/Brassiere": 199,
	"./icons/duotone-icons/Clothes/Brassiere.svg": 199,
	"./icons/duotone-icons/Clothes/Briefcase": 200,
	"./icons/duotone-icons/Clothes/Briefcase.svg": 200,
	"./icons/duotone-icons/Clothes/Cap": 201,
	"./icons/duotone-icons/Clothes/Cap.svg": 201,
	"./icons/duotone-icons/Clothes/Crown": 202,
	"./icons/duotone-icons/Clothes/Crown.svg": 202,
	"./icons/duotone-icons/Clothes/Dress": 203,
	"./icons/duotone-icons/Clothes/Dress.svg": 203,
	"./icons/duotone-icons/Clothes/Hanger": 204,
	"./icons/duotone-icons/Clothes/Hanger.svg": 204,
	"./icons/duotone-icons/Clothes/Hat": 205,
	"./icons/duotone-icons/Clothes/Hat.svg": 205,
	"./icons/duotone-icons/Clothes/Panties": 206,
	"./icons/duotone-icons/Clothes/Panties.svg": 206,
	"./icons/duotone-icons/Clothes/Shirt": 207,
	"./icons/duotone-icons/Clothes/Shirt.svg": 207,
	"./icons/duotone-icons/Clothes/Shoes": 208,
	"./icons/duotone-icons/Clothes/Shoes.svg": 208,
	"./icons/duotone-icons/Clothes/Shorts": 209,
	"./icons/duotone-icons/Clothes/Shorts.svg": 209,
	"./icons/duotone-icons/Clothes/Sneakers": 210,
	"./icons/duotone-icons/Clothes/Sneakers.svg": 210,
	"./icons/duotone-icons/Clothes/Socks": 211,
	"./icons/duotone-icons/Clothes/Socks.svg": 211,
	"./icons/duotone-icons/Clothes/Sun-glasses": 212,
	"./icons/duotone-icons/Clothes/Sun-glasses.svg": 212,
	"./icons/duotone-icons/Clothes/T-Shirt": 213,
	"./icons/duotone-icons/Clothes/T-Shirt.svg": 213,
	"./icons/duotone-icons/Clothes/Tie": 214,
	"./icons/duotone-icons/Clothes/Tie.svg": 214,
	"./icons/duotone-icons/Code/Backspace": 215,
	"./icons/duotone-icons/Code/Backspace.svg": 215,
	"./icons/duotone-icons/Code/CMD": 216,
	"./icons/duotone-icons/Code/CMD.svg": 216,
	"./icons/duotone-icons/Code/Code": 217,
	"./icons/duotone-icons/Code/Code.svg": 217,
	"./icons/duotone-icons/Code/Commit": 218,
	"./icons/duotone-icons/Code/Commit.svg": 218,
	"./icons/duotone-icons/Code/Compiling": 219,
	"./icons/duotone-icons/Code/Compiling.svg": 219,
	"./icons/duotone-icons/Code/Control": 220,
	"./icons/duotone-icons/Code/Control.svg": 220,
	"./icons/duotone-icons/Code/Done-circle": 221,
	"./icons/duotone-icons/Code/Done-circle.svg": 221,
	"./icons/duotone-icons/Code/Error-circle": 222,
	"./icons/duotone-icons/Code/Error-circle.svg": 222,
	"./icons/duotone-icons/Code/Git#1": 223,
	"./icons/duotone-icons/Code/Git#1.svg": 223,
	"./icons/duotone-icons/Code/Git#2": 224,
	"./icons/duotone-icons/Code/Git#2.svg": 224,
	"./icons/duotone-icons/Code/Git#3": 225,
	"./icons/duotone-icons/Code/Git#3.svg": 225,
	"./icons/duotone-icons/Code/Git#4": 226,
	"./icons/duotone-icons/Code/Git#4.svg": 226,
	"./icons/duotone-icons/Code/Git-1": 227,
	"./icons/duotone-icons/Code/Git-1.svg": 227,
	"./icons/duotone-icons/Code/Git-2": 228,
	"./icons/duotone-icons/Code/Git-2.svg": 228,
	"./icons/duotone-icons/Code/Git-3": 229,
	"./icons/duotone-icons/Code/Git-3.svg": 229,
	"./icons/duotone-icons/Code/Git-4": 230,
	"./icons/duotone-icons/Code/Git-4.svg": 230,
	"./icons/duotone-icons/Code/Github": 231,
	"./icons/duotone-icons/Code/Github.svg": 231,
	"./icons/duotone-icons/Code/Info-circle": 232,
	"./icons/duotone-icons/Code/Info-circle.svg": 232,
	"./icons/duotone-icons/Code/Left-circle": 233,
	"./icons/duotone-icons/Code/Left-circle.svg": 233,
	"./icons/duotone-icons/Code/Loading": 234,
	"./icons/duotone-icons/Code/Loading.svg": 234,
	"./icons/duotone-icons/Code/Lock-circle": 235,
	"./icons/duotone-icons/Code/Lock-circle.svg": 235,
	"./icons/duotone-icons/Code/Lock-overturning": 236,
	"./icons/duotone-icons/Code/Lock-overturning.svg": 236,
	"./icons/duotone-icons/Code/Minus": 237,
	"./icons/duotone-icons/Code/Minus.svg": 237,
	"./icons/duotone-icons/Code/Option": 238,
	"./icons/duotone-icons/Code/Option.svg": 238,
	"./icons/duotone-icons/Code/Plus": 239,
	"./icons/duotone-icons/Code/Plus.svg": 239,
	"./icons/duotone-icons/Code/Puzzle": 240,
	"./icons/duotone-icons/Code/Puzzle.svg": 240,
	"./icons/duotone-icons/Code/Question-circle": 241,
	"./icons/duotone-icons/Code/Question-circle.svg": 241,
	"./icons/duotone-icons/Code/Right-circle": 242,
	"./icons/duotone-icons/Code/Right-circle.svg": 242,
	"./icons/duotone-icons/Code/Settings#4": 243,
	"./icons/duotone-icons/Code/Settings#4.svg": 243,
	"./icons/duotone-icons/Code/Settings-4": 244,
	"./icons/duotone-icons/Code/Settings-4.svg": 244,
	"./icons/duotone-icons/Code/Shift": 245,
	"./icons/duotone-icons/Code/Shift.svg": 245,
	"./icons/duotone-icons/Code/Spy": 246,
	"./icons/duotone-icons/Code/Spy.svg": 246,
	"./icons/duotone-icons/Code/Stop": 247,
	"./icons/duotone-icons/Code/Stop.svg": 247,
	"./icons/duotone-icons/Code/Terminal": 248,
	"./icons/duotone-icons/Code/Terminal.svg": 248,
	"./icons/duotone-icons/Code/Thunder-circle": 249,
	"./icons/duotone-icons/Code/Thunder-circle.svg": 249,
	"./icons/duotone-icons/Code/Time-schedule": 250,
	"./icons/duotone-icons/Code/Time-schedule.svg": 250,
	"./icons/duotone-icons/Code/Warning-1-circle": 251,
	"./icons/duotone-icons/Code/Warning-1-circle.svg": 251,
	"./icons/duotone-icons/Code/Warning-2": 252,
	"./icons/duotone-icons/Code/Warning-2.svg": 252,
	"./icons/duotone-icons/Communication/Active-call": 253,
	"./icons/duotone-icons/Communication/Active-call.svg": 253,
	"./icons/duotone-icons/Communication/Add-user": 254,
	"./icons/duotone-icons/Communication/Add-user.svg": 254,
	"./icons/duotone-icons/Communication/Address-card": 255,
	"./icons/duotone-icons/Communication/Address-card.svg": 255,
	"./icons/duotone-icons/Communication/Adress-book#1": 256,
	"./icons/duotone-icons/Communication/Adress-book#1.svg": 256,
	"./icons/duotone-icons/Communication/Adress-book#2": 257,
	"./icons/duotone-icons/Communication/Adress-book#2.svg": 257,
	"./icons/duotone-icons/Communication/Adress-book-1": 258,
	"./icons/duotone-icons/Communication/Adress-book-1.svg": 258,
	"./icons/duotone-icons/Communication/Adress-book-2": 259,
	"./icons/duotone-icons/Communication/Adress-book-2.svg": 259,
	"./icons/duotone-icons/Communication/Archive": 260,
	"./icons/duotone-icons/Communication/Archive.svg": 260,
	"./icons/duotone-icons/Communication/Call": 261,
	"./icons/duotone-icons/Communication/Call#1": 262,
	"./icons/duotone-icons/Communication/Call#1.svg": 262,
	"./icons/duotone-icons/Communication/Call.svg": 261,
	"./icons/duotone-icons/Communication/Chat#1": 263,
	"./icons/duotone-icons/Communication/Chat#1.svg": 263,
	"./icons/duotone-icons/Communication/Chat#2": 264,
	"./icons/duotone-icons/Communication/Chat#2.svg": 264,
	"./icons/duotone-icons/Communication/Chat#4": 265,
	"./icons/duotone-icons/Communication/Chat#4.svg": 265,
	"./icons/duotone-icons/Communication/Chat#5": 266,
	"./icons/duotone-icons/Communication/Chat#5.svg": 266,
	"./icons/duotone-icons/Communication/Chat#6": 267,
	"./icons/duotone-icons/Communication/Chat#6.svg": 267,
	"./icons/duotone-icons/Communication/Chat-check": 268,
	"./icons/duotone-icons/Communication/Chat-check.svg": 268,
	"./icons/duotone-icons/Communication/Chat-error": 269,
	"./icons/duotone-icons/Communication/Chat-error.svg": 269,
	"./icons/duotone-icons/Communication/Chat-locked": 270,
	"./icons/duotone-icons/Communication/Chat-locked.svg": 270,
	"./icons/duotone-icons/Communication/Chat-smile": 271,
	"./icons/duotone-icons/Communication/Chat-smile.svg": 271,
	"./icons/duotone-icons/Communication/Clipboard-check": 272,
	"./icons/duotone-icons/Communication/Clipboard-check.svg": 272,
	"./icons/duotone-icons/Communication/Clipboard-list": 273,
	"./icons/duotone-icons/Communication/Clipboard-list.svg": 273,
	"./icons/duotone-icons/Communication/Contact#1": 274,
	"./icons/duotone-icons/Communication/Contact#1.svg": 274,
	"./icons/duotone-icons/Communication/Delete-user": 275,
	"./icons/duotone-icons/Communication/Delete-user.svg": 275,
	"./icons/duotone-icons/Communication/Dial-numbers": 276,
	"./icons/duotone-icons/Communication/Dial-numbers.svg": 276,
	"./icons/duotone-icons/Communication/Flag": 277,
	"./icons/duotone-icons/Communication/Flag.svg": 277,
	"./icons/duotone-icons/Communication/Forward": 278,
	"./icons/duotone-icons/Communication/Forward.svg": 278,
	"./icons/duotone-icons/Communication/Group": 279,
	"./icons/duotone-icons/Communication/Group-chat": 280,
	"./icons/duotone-icons/Communication/Group-chat.svg": 280,
	"./icons/duotone-icons/Communication/Group.svg": 279,
	"./icons/duotone-icons/Communication/Incoming-box": 281,
	"./icons/duotone-icons/Communication/Incoming-box.svg": 281,
	"./icons/duotone-icons/Communication/Incoming-call": 282,
	"./icons/duotone-icons/Communication/Incoming-call.svg": 282,
	"./icons/duotone-icons/Communication/Incoming-mail": 283,
	"./icons/duotone-icons/Communication/Incoming-mail.svg": 283,
	"./icons/duotone-icons/Communication/Mail": 284,
	"./icons/duotone-icons/Communication/Mail-@": 285,
	"./icons/duotone-icons/Communication/Mail-@.svg": 285,
	"./icons/duotone-icons/Communication/Mail-attachment": 286,
	"./icons/duotone-icons/Communication/Mail-attachment.svg": 286,
	"./icons/duotone-icons/Communication/Mail-box": 287,
	"./icons/duotone-icons/Communication/Mail-box.svg": 287,
	"./icons/duotone-icons/Communication/Mail-error": 288,
	"./icons/duotone-icons/Communication/Mail-error.svg": 288,
	"./icons/duotone-icons/Communication/Mail-heart": 289,
	"./icons/duotone-icons/Communication/Mail-heart.svg": 289,
	"./icons/duotone-icons/Communication/Mail-locked": 290,
	"./icons/duotone-icons/Communication/Mail-locked.svg": 290,
	"./icons/duotone-icons/Communication/Mail-notification": 291,
	"./icons/duotone-icons/Communication/Mail-notification.svg": 291,
	"./icons/duotone-icons/Communication/Mail-opened": 292,
	"./icons/duotone-icons/Communication/Mail-opened.svg": 292,
	"./icons/duotone-icons/Communication/Mail-unocked": 293,
	"./icons/duotone-icons/Communication/Mail-unocked.svg": 293,
	"./icons/duotone-icons/Communication/Mail.svg": 284,
	"./icons/duotone-icons/Communication/Missed-call": 294,
	"./icons/duotone-icons/Communication/Missed-call.svg": 294,
	"./icons/duotone-icons/Communication/Outgoing-box": 295,
	"./icons/duotone-icons/Communication/Outgoing-box.svg": 295,
	"./icons/duotone-icons/Communication/Outgoing-call": 296,
	"./icons/duotone-icons/Communication/Outgoing-call.svg": 296,
	"./icons/duotone-icons/Communication/Outgoing-mail": 297,
	"./icons/duotone-icons/Communication/Outgoing-mail.svg": 297,
	"./icons/duotone-icons/Communication/RSS": 298,
	"./icons/duotone-icons/Communication/RSS.svg": 298,
	"./icons/duotone-icons/Communication/Readed-mail": 299,
	"./icons/duotone-icons/Communication/Readed-mail.svg": 299,
	"./icons/duotone-icons/Communication/Reply": 300,
	"./icons/duotone-icons/Communication/Reply-all": 301,
	"./icons/duotone-icons/Communication/Reply-all.svg": 301,
	"./icons/duotone-icons/Communication/Reply.svg": 300,
	"./icons/duotone-icons/Communication/Right": 302,
	"./icons/duotone-icons/Communication/Right.svg": 302,
	"./icons/duotone-icons/Communication/Safe-chat": 303,
	"./icons/duotone-icons/Communication/Safe-chat.svg": 303,
	"./icons/duotone-icons/Communication/Send": 304,
	"./icons/duotone-icons/Communication/Send.svg": 304,
	"./icons/duotone-icons/Communication/Sending": 305,
	"./icons/duotone-icons/Communication/Sending mail": 306,
	"./icons/duotone-icons/Communication/Sending mail.svg": 306,
	"./icons/duotone-icons/Communication/Sending.svg": 305,
	"./icons/duotone-icons/Communication/Share": 307,
	"./icons/duotone-icons/Communication/Share.svg": 307,
	"./icons/duotone-icons/Communication/Shield-thunder": 308,
	"./icons/duotone-icons/Communication/Shield-thunder.svg": 308,
	"./icons/duotone-icons/Communication/Shield-user": 309,
	"./icons/duotone-icons/Communication/Shield-user.svg": 309,
	"./icons/duotone-icons/Communication/Snoozed-mail": 310,
	"./icons/duotone-icons/Communication/Snoozed-mail.svg": 310,
	"./icons/duotone-icons/Communication/Spam": 311,
	"./icons/duotone-icons/Communication/Spam.svg": 311,
	"./icons/duotone-icons/Communication/Thumbtack": 312,
	"./icons/duotone-icons/Communication/Thumbtack.svg": 312,
	"./icons/duotone-icons/Communication/Urgent-mail": 313,
	"./icons/duotone-icons/Communication/Urgent-mail.svg": 313,
	"./icons/duotone-icons/Communication/Write": 314,
	"./icons/duotone-icons/Communication/Write.svg": 314,
	"./icons/duotone-icons/Cooking/Baking-glove": 315,
	"./icons/duotone-icons/Cooking/Baking-glove.svg": 315,
	"./icons/duotone-icons/Cooking/Bowl": 316,
	"./icons/duotone-icons/Cooking/Bowl.svg": 316,
	"./icons/duotone-icons/Cooking/Chef": 317,
	"./icons/duotone-icons/Cooking/Chef.svg": 317,
	"./icons/duotone-icons/Cooking/Cooking-book": 318,
	"./icons/duotone-icons/Cooking/Cooking-book.svg": 318,
	"./icons/duotone-icons/Cooking/Cooking-pot": 319,
	"./icons/duotone-icons/Cooking/Cooking-pot.svg": 319,
	"./icons/duotone-icons/Cooking/Cutting board": 320,
	"./icons/duotone-icons/Cooking/Cutting board.svg": 320,
	"./icons/duotone-icons/Cooking/Dinner": 321,
	"./icons/duotone-icons/Cooking/Dinner.svg": 321,
	"./icons/duotone-icons/Cooking/Dish": 322,
	"./icons/duotone-icons/Cooking/Dish.svg": 322,
	"./icons/duotone-icons/Cooking/Dishes": 323,
	"./icons/duotone-icons/Cooking/Dishes.svg": 323,
	"./icons/duotone-icons/Cooking/Fork": 324,
	"./icons/duotone-icons/Cooking/Fork-spoon": 325,
	"./icons/duotone-icons/Cooking/Fork-spoon-knife": 326,
	"./icons/duotone-icons/Cooking/Fork-spoon-knife.svg": 326,
	"./icons/duotone-icons/Cooking/Fork-spoon.svg": 325,
	"./icons/duotone-icons/Cooking/Fork.svg": 324,
	"./icons/duotone-icons/Cooking/Frying-pan": 327,
	"./icons/duotone-icons/Cooking/Frying-pan.svg": 327,
	"./icons/duotone-icons/Cooking/Grater": 328,
	"./icons/duotone-icons/Cooking/Grater.svg": 328,
	"./icons/duotone-icons/Cooking/Kitchen-scale": 329,
	"./icons/duotone-icons/Cooking/Kitchen-scale.svg": 329,
	"./icons/duotone-icons/Cooking/Knife#1": 330,
	"./icons/duotone-icons/Cooking/Knife#1.svg": 330,
	"./icons/duotone-icons/Cooking/Knife#2": 331,
	"./icons/duotone-icons/Cooking/Knife#2.svg": 331,
	"./icons/duotone-icons/Cooking/Knife&fork#1": 332,
	"./icons/duotone-icons/Cooking/Knife&fork#1.svg": 332,
	"./icons/duotone-icons/Cooking/Knife&fork#2": 333,
	"./icons/duotone-icons/Cooking/Knife&fork#2.svg": 333,
	"./icons/duotone-icons/Cooking/Ladle": 334,
	"./icons/duotone-icons/Cooking/Ladle.svg": 334,
	"./icons/duotone-icons/Cooking/Rolling-pin": 335,
	"./icons/duotone-icons/Cooking/Rolling-pin.svg": 335,
	"./icons/duotone-icons/Cooking/Saucepan": 336,
	"./icons/duotone-icons/Cooking/Saucepan.svg": 336,
	"./icons/duotone-icons/Cooking/Shovel": 337,
	"./icons/duotone-icons/Cooking/Shovel.svg": 337,
	"./icons/duotone-icons/Cooking/Sieve": 338,
	"./icons/duotone-icons/Cooking/Sieve.svg": 338,
	"./icons/duotone-icons/Cooking/Spoon": 339,
	"./icons/duotone-icons/Cooking/Spoon.svg": 339,
	"./icons/duotone-icons/Design/Adjust": 340,
	"./icons/duotone-icons/Design/Adjust.svg": 340,
	"./icons/duotone-icons/Design/Anchor-center": 341,
	"./icons/duotone-icons/Design/Anchor-center-down": 342,
	"./icons/duotone-icons/Design/Anchor-center-down.svg": 342,
	"./icons/duotone-icons/Design/Anchor-center-up": 343,
	"./icons/duotone-icons/Design/Anchor-center-up.svg": 343,
	"./icons/duotone-icons/Design/Anchor-center.svg": 341,
	"./icons/duotone-icons/Design/Anchor-left": 344,
	"./icons/duotone-icons/Design/Anchor-left-down": 345,
	"./icons/duotone-icons/Design/Anchor-left-down.svg": 345,
	"./icons/duotone-icons/Design/Anchor-left-up": 346,
	"./icons/duotone-icons/Design/Anchor-left-up.svg": 346,
	"./icons/duotone-icons/Design/Anchor-left.svg": 344,
	"./icons/duotone-icons/Design/Anchor-right": 347,
	"./icons/duotone-icons/Design/Anchor-right-down": 348,
	"./icons/duotone-icons/Design/Anchor-right-down.svg": 348,
	"./icons/duotone-icons/Design/Anchor-right-up": 349,
	"./icons/duotone-icons/Design/Anchor-right-up.svg": 349,
	"./icons/duotone-icons/Design/Anchor-right.svg": 347,
	"./icons/duotone-icons/Design/Arrows": 350,
	"./icons/duotone-icons/Design/Arrows.svg": 350,
	"./icons/duotone-icons/Design/Bezier-curve": 351,
	"./icons/duotone-icons/Design/Bezier-curve.svg": 351,
	"./icons/duotone-icons/Design/Border": 352,
	"./icons/duotone-icons/Design/Border.svg": 352,
	"./icons/duotone-icons/Design/Brush": 353,
	"./icons/duotone-icons/Design/Brush.svg": 353,
	"./icons/duotone-icons/Design/Bucket": 354,
	"./icons/duotone-icons/Design/Bucket.svg": 354,
	"./icons/duotone-icons/Design/Cap-1": 355,
	"./icons/duotone-icons/Design/Cap-1.svg": 355,
	"./icons/duotone-icons/Design/Cap-2": 356,
	"./icons/duotone-icons/Design/Cap-2.svg": 356,
	"./icons/duotone-icons/Design/Cap-3": 357,
	"./icons/duotone-icons/Design/Cap-3.svg": 357,
	"./icons/duotone-icons/Design/Circle": 358,
	"./icons/duotone-icons/Design/Circle.svg": 358,
	"./icons/duotone-icons/Design/Color": 359,
	"./icons/duotone-icons/Design/Color-profile": 360,
	"./icons/duotone-icons/Design/Color-profile.svg": 360,
	"./icons/duotone-icons/Design/Color.svg": 359,
	"./icons/duotone-icons/Design/Component": 361,
	"./icons/duotone-icons/Design/Component.svg": 361,
	"./icons/duotone-icons/Design/Crop": 362,
	"./icons/duotone-icons/Design/Crop.svg": 362,
	"./icons/duotone-icons/Design/Difference": 363,
	"./icons/duotone-icons/Design/Difference.svg": 363,
	"./icons/duotone-icons/Design/Edit": 364,
	"./icons/duotone-icons/Design/Edit.svg": 364,
	"./icons/duotone-icons/Design/Eraser": 365,
	"./icons/duotone-icons/Design/Eraser.svg": 365,
	"./icons/duotone-icons/Design/Flatten": 366,
	"./icons/duotone-icons/Design/Flatten.svg": 366,
	"./icons/duotone-icons/Design/Flip-horizontal": 367,
	"./icons/duotone-icons/Design/Flip-horizontal.svg": 367,
	"./icons/duotone-icons/Design/Flip-vertical": 368,
	"./icons/duotone-icons/Design/Flip-vertical.svg": 368,
	"./icons/duotone-icons/Design/Horizontal": 369,
	"./icons/duotone-icons/Design/Horizontal.svg": 369,
	"./icons/duotone-icons/Design/Image": 370,
	"./icons/duotone-icons/Design/Image.svg": 370,
	"./icons/duotone-icons/Design/Interselect": 371,
	"./icons/duotone-icons/Design/Interselect.svg": 371,
	"./icons/duotone-icons/Design/Join-1": 372,
	"./icons/duotone-icons/Design/Join-1.svg": 372,
	"./icons/duotone-icons/Design/Join-2": 373,
	"./icons/duotone-icons/Design/Join-2.svg": 373,
	"./icons/duotone-icons/Design/Join-3": 374,
	"./icons/duotone-icons/Design/Join-3.svg": 374,
	"./icons/duotone-icons/Design/Layers": 375,
	"./icons/duotone-icons/Design/Layers.svg": 375,
	"./icons/duotone-icons/Design/Line": 376,
	"./icons/duotone-icons/Design/Line.svg": 376,
	"./icons/duotone-icons/Design/Magic": 377,
	"./icons/duotone-icons/Design/Magic.svg": 377,
	"./icons/duotone-icons/Design/Mask": 378,
	"./icons/duotone-icons/Design/Mask.svg": 378,
	"./icons/duotone-icons/Design/Patch": 379,
	"./icons/duotone-icons/Design/Patch.svg": 379,
	"./icons/duotone-icons/Design/Pen&ruller": 380,
	"./icons/duotone-icons/Design/Pen&ruller.svg": 380,
	"./icons/duotone-icons/Design/Pen-tool-vector": 381,
	"./icons/duotone-icons/Design/Pen-tool-vector.svg": 381,
	"./icons/duotone-icons/Design/Pencil": 382,
	"./icons/duotone-icons/Design/Pencil.svg": 382,
	"./icons/duotone-icons/Design/Picker": 383,
	"./icons/duotone-icons/Design/Picker.svg": 383,
	"./icons/duotone-icons/Design/Pixels": 384,
	"./icons/duotone-icons/Design/Pixels.svg": 384,
	"./icons/duotone-icons/Design/Polygon": 385,
	"./icons/duotone-icons/Design/Polygon.svg": 385,
	"./icons/duotone-icons/Design/Position": 386,
	"./icons/duotone-icons/Design/Position.svg": 386,
	"./icons/duotone-icons/Design/Rectangle": 387,
	"./icons/duotone-icons/Design/Rectangle.svg": 387,
	"./icons/duotone-icons/Design/Saturation": 388,
	"./icons/duotone-icons/Design/Saturation.svg": 388,
	"./icons/duotone-icons/Design/Select": 389,
	"./icons/duotone-icons/Design/Select.svg": 389,
	"./icons/duotone-icons/Design/Sketch": 390,
	"./icons/duotone-icons/Design/Sketch.svg": 390,
	"./icons/duotone-icons/Design/Stamp": 391,
	"./icons/duotone-icons/Design/Stamp.svg": 391,
	"./icons/duotone-icons/Design/Substract": 392,
	"./icons/duotone-icons/Design/Substract.svg": 392,
	"./icons/duotone-icons/Design/Target": 393,
	"./icons/duotone-icons/Design/Target.svg": 393,
	"./icons/duotone-icons/Design/Triangle": 394,
	"./icons/duotone-icons/Design/Triangle.svg": 394,
	"./icons/duotone-icons/Design/Union": 395,
	"./icons/duotone-icons/Design/Union.svg": 395,
	"./icons/duotone-icons/Design/Vertical": 396,
	"./icons/duotone-icons/Design/Vertical.svg": 396,
	"./icons/duotone-icons/Design/Zoom minus": 397,
	"./icons/duotone-icons/Design/Zoom minus.svg": 397,
	"./icons/duotone-icons/Design/Zoom plus": 398,
	"./icons/duotone-icons/Design/Zoom plus.svg": 398,
	"./icons/duotone-icons/Devices/Airpods": 399,
	"./icons/duotone-icons/Devices/Airpods.svg": 399,
	"./icons/duotone-icons/Devices/Android": 400,
	"./icons/duotone-icons/Devices/Android.svg": 400,
	"./icons/duotone-icons/Devices/Apple-Watch": 401,
	"./icons/duotone-icons/Devices/Apple-Watch.svg": 401,
	"./icons/duotone-icons/Devices/Battery-charging": 402,
	"./icons/duotone-icons/Devices/Battery-charging.svg": 402,
	"./icons/duotone-icons/Devices/Battery-empty": 403,
	"./icons/duotone-icons/Devices/Battery-empty.svg": 403,
	"./icons/duotone-icons/Devices/Battery-full": 404,
	"./icons/duotone-icons/Devices/Battery-full.svg": 404,
	"./icons/duotone-icons/Devices/Battery-half": 405,
	"./icons/duotone-icons/Devices/Battery-half.svg": 405,
	"./icons/duotone-icons/Devices/Bluetooth": 406,
	"./icons/duotone-icons/Devices/Bluetooth.svg": 406,
	"./icons/duotone-icons/Devices/CPU#1": 407,
	"./icons/duotone-icons/Devices/CPU#1.svg": 407,
	"./icons/duotone-icons/Devices/CPU#2": 408,
	"./icons/duotone-icons/Devices/CPU#2.svg": 408,
	"./icons/duotone-icons/Devices/Camera": 409,
	"./icons/duotone-icons/Devices/Camera.svg": 409,
	"./icons/duotone-icons/Devices/Cardboard-vr": 410,
	"./icons/duotone-icons/Devices/Cardboard-vr.svg": 410,
	"./icons/duotone-icons/Devices/Cassete": 411,
	"./icons/duotone-icons/Devices/Cassete.svg": 411,
	"./icons/duotone-icons/Devices/Diagnostics": 412,
	"./icons/duotone-icons/Devices/Diagnostics.svg": 412,
	"./icons/duotone-icons/Devices/Display#1": 413,
	"./icons/duotone-icons/Devices/Display#1.svg": 413,
	"./icons/duotone-icons/Devices/Display#2": 414,
	"./icons/duotone-icons/Devices/Display#2.svg": 414,
	"./icons/duotone-icons/Devices/Display#3": 415,
	"./icons/duotone-icons/Devices/Display#3.svg": 415,
	"./icons/duotone-icons/Devices/Gameboy": 416,
	"./icons/duotone-icons/Devices/Gameboy.svg": 416,
	"./icons/duotone-icons/Devices/Gamepad#1": 417,
	"./icons/duotone-icons/Devices/Gamepad#1.svg": 417,
	"./icons/duotone-icons/Devices/Gamepad#2": 418,
	"./icons/duotone-icons/Devices/Gamepad#2.svg": 418,
	"./icons/duotone-icons/Devices/Generator": 419,
	"./icons/duotone-icons/Devices/Generator.svg": 419,
	"./icons/duotone-icons/Devices/Hard-drive": 420,
	"./icons/duotone-icons/Devices/Hard-drive.svg": 420,
	"./icons/duotone-icons/Devices/Headphones": 421,
	"./icons/duotone-icons/Devices/Headphones.svg": 421,
	"./icons/duotone-icons/Devices/Homepod": 422,
	"./icons/duotone-icons/Devices/Homepod.svg": 422,
	"./icons/duotone-icons/Devices/Keyboard": 423,
	"./icons/duotone-icons/Devices/Keyboard.svg": 423,
	"./icons/duotone-icons/Devices/LTE#1": 424,
	"./icons/duotone-icons/Devices/LTE#1.svg": 424,
	"./icons/duotone-icons/Devices/LTE#2": 425,
	"./icons/duotone-icons/Devices/LTE#2.svg": 425,
	"./icons/duotone-icons/Devices/Laptop": 426,
	"./icons/duotone-icons/Devices/Laptop-macbook": 427,
	"./icons/duotone-icons/Devices/Laptop-macbook.svg": 427,
	"./icons/duotone-icons/Devices/Laptop.svg": 426,
	"./icons/duotone-icons/Devices/Mic": 428,
	"./icons/duotone-icons/Devices/Mic.svg": 428,
	"./icons/duotone-icons/Devices/Midi": 429,
	"./icons/duotone-icons/Devices/Midi.svg": 429,
	"./icons/duotone-icons/Devices/Mouse": 430,
	"./icons/duotone-icons/Devices/Mouse.svg": 430,
	"./icons/duotone-icons/Devices/Phone": 431,
	"./icons/duotone-icons/Devices/Phone.svg": 431,
	"./icons/duotone-icons/Devices/Printer": 432,
	"./icons/duotone-icons/Devices/Printer.svg": 432,
	"./icons/duotone-icons/Devices/Radio": 433,
	"./icons/duotone-icons/Devices/Radio.svg": 433,
	"./icons/duotone-icons/Devices/Router#1": 434,
	"./icons/duotone-icons/Devices/Router#1.svg": 434,
	"./icons/duotone-icons/Devices/Router#2": 435,
	"./icons/duotone-icons/Devices/Router#2.svg": 435,
	"./icons/duotone-icons/Devices/SD-card": 436,
	"./icons/duotone-icons/Devices/SD-card.svg": 436,
	"./icons/duotone-icons/Devices/Server": 437,
	"./icons/duotone-icons/Devices/Server.svg": 437,
	"./icons/duotone-icons/Devices/Speaker": 438,
	"./icons/duotone-icons/Devices/Speaker.svg": 438,
	"./icons/duotone-icons/Devices/TV#1": 439,
	"./icons/duotone-icons/Devices/TV#1.svg": 439,
	"./icons/duotone-icons/Devices/TV#2": 440,
	"./icons/duotone-icons/Devices/TV#2.svg": 440,
	"./icons/duotone-icons/Devices/Tablet": 441,
	"./icons/duotone-icons/Devices/Tablet.svg": 441,
	"./icons/duotone-icons/Devices/USB": 442,
	"./icons/duotone-icons/Devices/USB.svg": 442,
	"./icons/duotone-icons/Devices/Usb-storage": 443,
	"./icons/duotone-icons/Devices/Usb-storage.svg": 443,
	"./icons/duotone-icons/Devices/Video-camera": 444,
	"./icons/duotone-icons/Devices/Video-camera.svg": 444,
	"./icons/duotone-icons/Devices/Watch#1": 445,
	"./icons/duotone-icons/Devices/Watch#1.svg": 445,
	"./icons/duotone-icons/Devices/Watch#2": 446,
	"./icons/duotone-icons/Devices/Watch#2.svg": 446,
	"./icons/duotone-icons/Devices/Wi-fi": 447,
	"./icons/duotone-icons/Devices/Wi-fi.svg": 447,
	"./icons/duotone-icons/Devices/iMac": 448,
	"./icons/duotone-icons/Devices/iMac.svg": 448,
	"./icons/duotone-icons/Devices/iPhone-X": 449,
	"./icons/duotone-icons/Devices/iPhone-X.svg": 449,
	"./icons/duotone-icons/Devices/iPhone-back": 450,
	"./icons/duotone-icons/Devices/iPhone-back.svg": 450,
	"./icons/duotone-icons/Devices/iPhone-x-back": 451,
	"./icons/duotone-icons/Devices/iPhone-x-back.svg": 451,
	"./icons/duotone-icons/Electric/Air-conditioning": 452,
	"./icons/duotone-icons/Electric/Air-conditioning.svg": 452,
	"./icons/duotone-icons/Electric/Blender": 453,
	"./icons/duotone-icons/Electric/Blender.svg": 453,
	"./icons/duotone-icons/Electric/Fan": 454,
	"./icons/duotone-icons/Electric/Fan.svg": 454,
	"./icons/duotone-icons/Electric/Fridge": 455,
	"./icons/duotone-icons/Electric/Fridge.svg": 455,
	"./icons/duotone-icons/Electric/Gas-stove": 456,
	"./icons/duotone-icons/Electric/Gas-stove.svg": 456,
	"./icons/duotone-icons/Electric/Hair-dryer": 457,
	"./icons/duotone-icons/Electric/Hair-dryer.svg": 457,
	"./icons/duotone-icons/Electric/Highvoltage": 458,
	"./icons/duotone-icons/Electric/Highvoltage.svg": 458,
	"./icons/duotone-icons/Electric/Iron": 459,
	"./icons/duotone-icons/Electric/Iron.svg": 459,
	"./icons/duotone-icons/Electric/Kettle": 460,
	"./icons/duotone-icons/Electric/Kettle.svg": 460,
	"./icons/duotone-icons/Electric/Mixer": 461,
	"./icons/duotone-icons/Electric/Mixer.svg": 461,
	"./icons/duotone-icons/Electric/Outlet": 462,
	"./icons/duotone-icons/Electric/Outlet.svg": 462,
	"./icons/duotone-icons/Electric/Range-hood": 463,
	"./icons/duotone-icons/Electric/Range-hood.svg": 463,
	"./icons/duotone-icons/Electric/Shutdown": 464,
	"./icons/duotone-icons/Electric/Shutdown.svg": 464,
	"./icons/duotone-icons/Electric/Socket-eu": 465,
	"./icons/duotone-icons/Electric/Socket-eu.svg": 465,
	"./icons/duotone-icons/Electric/Socket-us": 466,
	"./icons/duotone-icons/Electric/Socket-us.svg": 466,
	"./icons/duotone-icons/Electric/Washer": 467,
	"./icons/duotone-icons/Electric/Washer.svg": 467,
	"./icons/duotone-icons/Files/Cloud-download": 468,
	"./icons/duotone-icons/Files/Cloud-download.svg": 468,
	"./icons/duotone-icons/Files/Cloud-upload": 469,
	"./icons/duotone-icons/Files/Cloud-upload.svg": 469,
	"./icons/duotone-icons/Files/Compilation": 470,
	"./icons/duotone-icons/Files/Compilation.svg": 470,
	"./icons/duotone-icons/Files/Compiled-file": 471,
	"./icons/duotone-icons/Files/Compiled-file.svg": 471,
	"./icons/duotone-icons/Files/Deleted-file": 472,
	"./icons/duotone-icons/Files/Deleted-file.svg": 472,
	"./icons/duotone-icons/Files/Deleted-folder": 473,
	"./icons/duotone-icons/Files/Deleted-folder.svg": 473,
	"./icons/duotone-icons/Files/Download": 474,
	"./icons/duotone-icons/Files/Download.svg": 474,
	"./icons/duotone-icons/Files/Downloaded file": 475,
	"./icons/duotone-icons/Files/Downloaded file.svg": 475,
	"./icons/duotone-icons/Files/Downloads-folder": 476,
	"./icons/duotone-icons/Files/Downloads-folder.svg": 476,
	"./icons/duotone-icons/Files/Export": 477,
	"./icons/duotone-icons/Files/Export.svg": 477,
	"./icons/duotone-icons/Files/File": 478,
	"./icons/duotone-icons/Files/File-cloud": 479,
	"./icons/duotone-icons/Files/File-cloud.svg": 479,
	"./icons/duotone-icons/Files/File-done": 480,
	"./icons/duotone-icons/Files/File-done.svg": 480,
	"./icons/duotone-icons/Files/File-minus": 481,
	"./icons/duotone-icons/Files/File-minus.svg": 481,
	"./icons/duotone-icons/Files/File-plus": 482,
	"./icons/duotone-icons/Files/File-plus.svg": 482,
	"./icons/duotone-icons/Files/File.svg": 478,
	"./icons/duotone-icons/Files/Folder": 483,
	"./icons/duotone-icons/Files/Folder-check": 484,
	"./icons/duotone-icons/Files/Folder-check.svg": 484,
	"./icons/duotone-icons/Files/Folder-cloud": 485,
	"./icons/duotone-icons/Files/Folder-cloud.svg": 485,
	"./icons/duotone-icons/Files/Folder-error": 486,
	"./icons/duotone-icons/Files/Folder-error.svg": 486,
	"./icons/duotone-icons/Files/Folder-heart": 487,
	"./icons/duotone-icons/Files/Folder-heart.svg": 487,
	"./icons/duotone-icons/Files/Folder-minus": 488,
	"./icons/duotone-icons/Files/Folder-minus.svg": 488,
	"./icons/duotone-icons/Files/Folder-plus": 489,
	"./icons/duotone-icons/Files/Folder-plus.svg": 489,
	"./icons/duotone-icons/Files/Folder-solid": 490,
	"./icons/duotone-icons/Files/Folder-solid.svg": 490,
	"./icons/duotone-icons/Files/Folder-star": 491,
	"./icons/duotone-icons/Files/Folder-star.svg": 491,
	"./icons/duotone-icons/Files/Folder-thunder": 492,
	"./icons/duotone-icons/Files/Folder-thunder.svg": 492,
	"./icons/duotone-icons/Files/Folder.svg": 483,
	"./icons/duotone-icons/Files/Group-folders": 493,
	"./icons/duotone-icons/Files/Group-folders.svg": 493,
	"./icons/duotone-icons/Files/Import": 494,
	"./icons/duotone-icons/Files/Import.svg": 494,
	"./icons/duotone-icons/Files/Locked-folder": 495,
	"./icons/duotone-icons/Files/Locked-folder.svg": 495,
	"./icons/duotone-icons/Files/Media": 496,
	"./icons/duotone-icons/Files/Media-folder": 497,
	"./icons/duotone-icons/Files/Media-folder.svg": 497,
	"./icons/duotone-icons/Files/Media.svg": 496,
	"./icons/duotone-icons/Files/Music": 498,
	"./icons/duotone-icons/Files/Music.svg": 498,
	"./icons/duotone-icons/Files/Pictures#1": 499,
	"./icons/duotone-icons/Files/Pictures#1.svg": 499,
	"./icons/duotone-icons/Files/Pictures#2": 500,
	"./icons/duotone-icons/Files/Pictures#2.svg": 500,
	"./icons/duotone-icons/Files/Protected-file": 501,
	"./icons/duotone-icons/Files/Protected-file.svg": 501,
	"./icons/duotone-icons/Files/Selected-file": 502,
	"./icons/duotone-icons/Files/Selected-file.svg": 502,
	"./icons/duotone-icons/Files/Share": 503,
	"./icons/duotone-icons/Files/Share.svg": 503,
	"./icons/duotone-icons/Files/Upload": 504,
	"./icons/duotone-icons/Files/Upload-folder": 505,
	"./icons/duotone-icons/Files/Upload-folder.svg": 505,
	"./icons/duotone-icons/Files/Upload.svg": 504,
	"./icons/duotone-icons/Files/Uploaded-file": 506,
	"./icons/duotone-icons/Files/Uploaded-file.svg": 506,
	"./icons/duotone-icons/Files/User-folder": 507,
	"./icons/duotone-icons/Files/User-folder.svg": 507,
	"./icons/duotone-icons/Food/Beer": 508,
	"./icons/duotone-icons/Food/Beer.svg": 508,
	"./icons/duotone-icons/Food/Bottle#1": 509,
	"./icons/duotone-icons/Food/Bottle#1.svg": 509,
	"./icons/duotone-icons/Food/Bottle#2": 510,
	"./icons/duotone-icons/Food/Bottle#2.svg": 510,
	"./icons/duotone-icons/Food/Bread": 511,
	"./icons/duotone-icons/Food/Bread.svg": 511,
	"./icons/duotone-icons/Food/Bucket": 512,
	"./icons/duotone-icons/Food/Bucket.svg": 512,
	"./icons/duotone-icons/Food/Burger": 513,
	"./icons/duotone-icons/Food/Burger.svg": 513,
	"./icons/duotone-icons/Food/Cake": 514,
	"./icons/duotone-icons/Food/Cake.svg": 514,
	"./icons/duotone-icons/Food/Carrot": 515,
	"./icons/duotone-icons/Food/Carrot.svg": 515,
	"./icons/duotone-icons/Food/Cheese": 516,
	"./icons/duotone-icons/Food/Cheese.svg": 516,
	"./icons/duotone-icons/Food/Chicken": 517,
	"./icons/duotone-icons/Food/Chicken.svg": 517,
	"./icons/duotone-icons/Food/Coffee#1": 518,
	"./icons/duotone-icons/Food/Coffee#1.svg": 518,
	"./icons/duotone-icons/Food/Coffee#2": 519,
	"./icons/duotone-icons/Food/Coffee#2.svg": 519,
	"./icons/duotone-icons/Food/Cookie": 520,
	"./icons/duotone-icons/Food/Cookie.svg": 520,
	"./icons/duotone-icons/Food/Dinner": 521,
	"./icons/duotone-icons/Food/Dinner.svg": 521,
	"./icons/duotone-icons/Food/Fish": 522,
	"./icons/duotone-icons/Food/Fish.svg": 522,
	"./icons/duotone-icons/Food/French Bread": 523,
	"./icons/duotone-icons/Food/French Bread.svg": 523,
	"./icons/duotone-icons/Food/Glass-martini": 524,
	"./icons/duotone-icons/Food/Glass-martini.svg": 524,
	"./icons/duotone-icons/Food/Ice-cream#1": 525,
	"./icons/duotone-icons/Food/Ice-cream#1.svg": 525,
	"./icons/duotone-icons/Food/Ice-cream#2": 526,
	"./icons/duotone-icons/Food/Ice-cream#2.svg": 526,
	"./icons/duotone-icons/Food/Miso-soup": 527,
	"./icons/duotone-icons/Food/Miso-soup.svg": 527,
	"./icons/duotone-icons/Food/Orange": 528,
	"./icons/duotone-icons/Food/Orange.svg": 528,
	"./icons/duotone-icons/Food/Pizza": 529,
	"./icons/duotone-icons/Food/Pizza.svg": 529,
	"./icons/duotone-icons/Food/Sushi": 530,
	"./icons/duotone-icons/Food/Sushi.svg": 530,
	"./icons/duotone-icons/Food/Two-bottles": 531,
	"./icons/duotone-icons/Food/Two-bottles.svg": 531,
	"./icons/duotone-icons/Food/Wine": 532,
	"./icons/duotone-icons/Food/Wine.svg": 532,
	"./icons/duotone-icons/General/Attachment#1": 533,
	"./icons/duotone-icons/General/Attachment#1.svg": 533,
	"./icons/duotone-icons/General/Attachment#2": 534,
	"./icons/duotone-icons/General/Attachment#2.svg": 534,
	"./icons/duotone-icons/General/Binocular": 535,
	"./icons/duotone-icons/General/Binocular.svg": 535,
	"./icons/duotone-icons/General/Bookmark": 536,
	"./icons/duotone-icons/General/Bookmark.svg": 536,
	"./icons/duotone-icons/General/Clip": 537,
	"./icons/duotone-icons/General/Clip.svg": 537,
	"./icons/duotone-icons/General/Clipboard": 538,
	"./icons/duotone-icons/General/Clipboard.svg": 538,
	"./icons/duotone-icons/General/Cursor": 539,
	"./icons/duotone-icons/General/Cursor.svg": 539,
	"./icons/duotone-icons/General/Dislike": 540,
	"./icons/duotone-icons/General/Dislike.svg": 540,
	"./icons/duotone-icons/General/Duplicate": 541,
	"./icons/duotone-icons/General/Duplicate.svg": 541,
	"./icons/duotone-icons/General/Edit": 542,
	"./icons/duotone-icons/General/Edit.svg": 542,
	"./icons/duotone-icons/General/Expand-arrows": 543,
	"./icons/duotone-icons/General/Expand-arrows.svg": 543,
	"./icons/duotone-icons/General/Fire": 544,
	"./icons/duotone-icons/General/Fire.svg": 544,
	"./icons/duotone-icons/General/Folder": 545,
	"./icons/duotone-icons/General/Folder.svg": 545,
	"./icons/duotone-icons/General/Half-heart": 546,
	"./icons/duotone-icons/General/Half-heart.svg": 546,
	"./icons/duotone-icons/General/Half-star": 547,
	"./icons/duotone-icons/General/Half-star.svg": 547,
	"./icons/duotone-icons/General/Heart": 548,
	"./icons/duotone-icons/General/Heart.svg": 548,
	"./icons/duotone-icons/General/Hidden": 549,
	"./icons/duotone-icons/General/Hidden.svg": 549,
	"./icons/duotone-icons/General/Like": 550,
	"./icons/duotone-icons/General/Like.svg": 550,
	"./icons/duotone-icons/General/Lock": 551,
	"./icons/duotone-icons/General/Lock.svg": 551,
	"./icons/duotone-icons/General/Notification#2": 552,
	"./icons/duotone-icons/General/Notification#2.svg": 552,
	"./icons/duotone-icons/General/Notifications#1": 553,
	"./icons/duotone-icons/General/Notifications#1.svg": 553,
	"./icons/duotone-icons/General/Other#1": 554,
	"./icons/duotone-icons/General/Other#1.svg": 554,
	"./icons/duotone-icons/General/Other#2": 555,
	"./icons/duotone-icons/General/Other#2.svg": 555,
	"./icons/duotone-icons/General/Sad": 556,
	"./icons/duotone-icons/General/Sad.svg": 556,
	"./icons/duotone-icons/General/Save": 557,
	"./icons/duotone-icons/General/Save.svg": 557,
	"./icons/duotone-icons/General/Scale": 558,
	"./icons/duotone-icons/General/Scale.svg": 558,
	"./icons/duotone-icons/General/Scissors": 559,
	"./icons/duotone-icons/General/Scissors.svg": 559,
	"./icons/duotone-icons/General/Search": 560,
	"./icons/duotone-icons/General/Search.svg": 560,
	"./icons/duotone-icons/General/Settings#3": 561,
	"./icons/duotone-icons/General/Settings#3.svg": 561,
	"./icons/duotone-icons/General/Settings-1": 562,
	"./icons/duotone-icons/General/Settings-1.svg": 562,
	"./icons/duotone-icons/General/Settings-2": 563,
	"./icons/duotone-icons/General/Settings-2.svg": 563,
	"./icons/duotone-icons/General/Shield-check": 564,
	"./icons/duotone-icons/General/Shield-check.svg": 564,
	"./icons/duotone-icons/General/Shield-disabled": 565,
	"./icons/duotone-icons/General/Shield-disabled.svg": 565,
	"./icons/duotone-icons/General/Shield-protected": 566,
	"./icons/duotone-icons/General/Shield-protected.svg": 566,
	"./icons/duotone-icons/General/Size": 567,
	"./icons/duotone-icons/General/Size.svg": 567,
	"./icons/duotone-icons/General/Smile": 568,
	"./icons/duotone-icons/General/Smile.svg": 568,
	"./icons/duotone-icons/General/Star": 569,
	"./icons/duotone-icons/General/Star.svg": 569,
	"./icons/duotone-icons/General/Thunder": 570,
	"./icons/duotone-icons/General/Thunder-move": 571,
	"./icons/duotone-icons/General/Thunder-move.svg": 571,
	"./icons/duotone-icons/General/Thunder.svg": 570,
	"./icons/duotone-icons/General/Trash": 572,
	"./icons/duotone-icons/General/Trash.svg": 572,
	"./icons/duotone-icons/General/Unlock": 573,
	"./icons/duotone-icons/General/Unlock.svg": 573,
	"./icons/duotone-icons/General/Update": 574,
	"./icons/duotone-icons/General/Update.svg": 574,
	"./icons/duotone-icons/General/User": 575,
	"./icons/duotone-icons/General/User.svg": 575,
	"./icons/duotone-icons/General/Visible": 576,
	"./icons/duotone-icons/General/Visible.svg": 576,
	"./icons/duotone-icons/Home/Air-ballon": 577,
	"./icons/duotone-icons/Home/Air-ballon.svg": 577,
	"./icons/duotone-icons/Home/Alarm-clock": 578,
	"./icons/duotone-icons/Home/Alarm-clock.svg": 578,
	"./icons/duotone-icons/Home/Armchair": 579,
	"./icons/duotone-icons/Home/Armchair.svg": 579,
	"./icons/duotone-icons/Home/Bag-chair": 580,
	"./icons/duotone-icons/Home/Bag-chair.svg": 580,
	"./icons/duotone-icons/Home/Bath": 581,
	"./icons/duotone-icons/Home/Bath.svg": 581,
	"./icons/duotone-icons/Home/Bed": 582,
	"./icons/duotone-icons/Home/Bed.svg": 582,
	"./icons/duotone-icons/Home/Book": 583,
	"./icons/duotone-icons/Home/Book-open": 584,
	"./icons/duotone-icons/Home/Book-open.svg": 584,
	"./icons/duotone-icons/Home/Book.svg": 583,
	"./icons/duotone-icons/Home/Box": 585,
	"./icons/duotone-icons/Home/Box.svg": 585,
	"./icons/duotone-icons/Home/Broom": 586,
	"./icons/duotone-icons/Home/Broom.svg": 586,
	"./icons/duotone-icons/Home/Building": 587,
	"./icons/duotone-icons/Home/Building.svg": 587,
	"./icons/duotone-icons/Home/Bulb#1": 588,
	"./icons/duotone-icons/Home/Bulb#1.svg": 588,
	"./icons/duotone-icons/Home/Bulb#2": 589,
	"./icons/duotone-icons/Home/Bulb#2.svg": 589,
	"./icons/duotone-icons/Home/Chair#1": 590,
	"./icons/duotone-icons/Home/Chair#1.svg": 590,
	"./icons/duotone-icons/Home/Chair#2": 591,
	"./icons/duotone-icons/Home/Chair#2.svg": 591,
	"./icons/duotone-icons/Home/Clock": 592,
	"./icons/duotone-icons/Home/Clock.svg": 592,
	"./icons/duotone-icons/Home/Commode#1": 593,
	"./icons/duotone-icons/Home/Commode#1.svg": 593,
	"./icons/duotone-icons/Home/Commode#2": 594,
	"./icons/duotone-icons/Home/Commode#2.svg": 594,
	"./icons/duotone-icons/Home/Couch": 595,
	"./icons/duotone-icons/Home/Couch.svg": 595,
	"./icons/duotone-icons/Home/Cupboard": 596,
	"./icons/duotone-icons/Home/Cupboard.svg": 596,
	"./icons/duotone-icons/Home/Curtains": 597,
	"./icons/duotone-icons/Home/Curtains.svg": 597,
	"./icons/duotone-icons/Home/Deer": 598,
	"./icons/duotone-icons/Home/Deer.svg": 598,
	"./icons/duotone-icons/Home/Door-open": 599,
	"./icons/duotone-icons/Home/Door-open.svg": 599,
	"./icons/duotone-icons/Home/Earth": 600,
	"./icons/duotone-icons/Home/Earth.svg": 600,
	"./icons/duotone-icons/Home/Fireplace": 601,
	"./icons/duotone-icons/Home/Fireplace.svg": 601,
	"./icons/duotone-icons/Home/Flashlight": 602,
	"./icons/duotone-icons/Home/Flashlight.svg": 602,
	"./icons/duotone-icons/Home/Flower#1": 603,
	"./icons/duotone-icons/Home/Flower#1.svg": 603,
	"./icons/duotone-icons/Home/Flower#2": 604,
	"./icons/duotone-icons/Home/Flower#2.svg": 604,
	"./icons/duotone-icons/Home/Flower#3": 605,
	"./icons/duotone-icons/Home/Flower#3.svg": 605,
	"./icons/duotone-icons/Home/Globe": 606,
	"./icons/duotone-icons/Home/Globe.svg": 606,
	"./icons/duotone-icons/Home/Home": 607,
	"./icons/duotone-icons/Home/Home-heart": 608,
	"./icons/duotone-icons/Home/Home-heart.svg": 608,
	"./icons/duotone-icons/Home/Home.svg": 607,
	"./icons/duotone-icons/Home/Key": 609,
	"./icons/duotone-icons/Home/Key.svg": 609,
	"./icons/duotone-icons/Home/Ladder": 610,
	"./icons/duotone-icons/Home/Ladder.svg": 610,
	"./icons/duotone-icons/Home/Lamp#1": 611,
	"./icons/duotone-icons/Home/Lamp#1.svg": 611,
	"./icons/duotone-icons/Home/Lamp#2": 612,
	"./icons/duotone-icons/Home/Lamp#2.svg": 612,
	"./icons/duotone-icons/Home/Library": 613,
	"./icons/duotone-icons/Home/Library.svg": 613,
	"./icons/duotone-icons/Home/Mailbox": 614,
	"./icons/duotone-icons/Home/Mailbox.svg": 614,
	"./icons/duotone-icons/Home/Mirror": 615,
	"./icons/duotone-icons/Home/Mirror.svg": 615,
	"./icons/duotone-icons/Home/Picture": 616,
	"./icons/duotone-icons/Home/Picture.svg": 616,
	"./icons/duotone-icons/Home/Ruller": 617,
	"./icons/duotone-icons/Home/Ruller.svg": 617,
	"./icons/duotone-icons/Home/Stairs": 618,
	"./icons/duotone-icons/Home/Stairs.svg": 618,
	"./icons/duotone-icons/Home/Timer": 619,
	"./icons/duotone-icons/Home/Timer.svg": 619,
	"./icons/duotone-icons/Home/Toilet": 620,
	"./icons/duotone-icons/Home/Toilet.svg": 620,
	"./icons/duotone-icons/Home/Towel": 621,
	"./icons/duotone-icons/Home/Towel.svg": 621,
	"./icons/duotone-icons/Home/Trash": 622,
	"./icons/duotone-icons/Home/Trash.svg": 622,
	"./icons/duotone-icons/Home/Water-mixer": 623,
	"./icons/duotone-icons/Home/Water-mixer.svg": 623,
	"./icons/duotone-icons/Home/Weight#1": 624,
	"./icons/duotone-icons/Home/Weight#1.svg": 624,
	"./icons/duotone-icons/Home/Weight#2": 625,
	"./icons/duotone-icons/Home/Weight#2.svg": 625,
	"./icons/duotone-icons/Home/Wood#1": 626,
	"./icons/duotone-icons/Home/Wood#1.svg": 626,
	"./icons/duotone-icons/Home/Wood#2": 627,
	"./icons/duotone-icons/Home/Wood#2.svg": 627,
	"./icons/duotone-icons/Home/Wood-horse": 628,
	"./icons/duotone-icons/Home/Wood-horse.svg": 628,
	"./icons/duotone-icons/Layout/Layout-3d": 629,
	"./icons/duotone-icons/Layout/Layout-3d.svg": 629,
	"./icons/duotone-icons/Layout/Layout-4-blocks": 630,
	"./icons/duotone-icons/Layout/Layout-4-blocks.svg": 630,
	"./icons/duotone-icons/Layout/Layout-arrange": 631,
	"./icons/duotone-icons/Layout/Layout-arrange.svg": 631,
	"./icons/duotone-icons/Layout/Layout-grid": 632,
	"./icons/duotone-icons/Layout/Layout-grid.svg": 632,
	"./icons/duotone-icons/Layout/Layout-horizontal": 633,
	"./icons/duotone-icons/Layout/Layout-horizontal.svg": 633,
	"./icons/duotone-icons/Layout/Layout-left-panel-1": 634,
	"./icons/duotone-icons/Layout/Layout-left-panel-1.svg": 634,
	"./icons/duotone-icons/Layout/Layout-left-panel-2": 635,
	"./icons/duotone-icons/Layout/Layout-left-panel-2.svg": 635,
	"./icons/duotone-icons/Layout/Layout-right-panel-1": 636,
	"./icons/duotone-icons/Layout/Layout-right-panel-1.svg": 636,
	"./icons/duotone-icons/Layout/Layout-right-panel-2": 637,
	"./icons/duotone-icons/Layout/Layout-right-panel-2.svg": 637,
	"./icons/duotone-icons/Layout/Layout-top-panel-1": 638,
	"./icons/duotone-icons/Layout/Layout-top-panel-1.svg": 638,
	"./icons/duotone-icons/Layout/Layout-top-panel-2": 639,
	"./icons/duotone-icons/Layout/Layout-top-panel-2.svg": 639,
	"./icons/duotone-icons/Layout/Layout-top-panel-3": 640,
	"./icons/duotone-icons/Layout/Layout-top-panel-3.svg": 640,
	"./icons/duotone-icons/Layout/Layout-top-panel-4": 641,
	"./icons/duotone-icons/Layout/Layout-top-panel-4.svg": 641,
	"./icons/duotone-icons/Layout/Layout-top-panel-5": 642,
	"./icons/duotone-icons/Layout/Layout-top-panel-5.svg": 642,
	"./icons/duotone-icons/Layout/Layout-top-panel-6": 643,
	"./icons/duotone-icons/Layout/Layout-top-panel-6.svg": 643,
	"./icons/duotone-icons/Layout/Layout-vertical": 644,
	"./icons/duotone-icons/Layout/Layout-vertical.svg": 644,
	"./icons/duotone-icons/Map/Compass": 645,
	"./icons/duotone-icons/Map/Compass.svg": 645,
	"./icons/duotone-icons/Map/Direction#1": 646,
	"./icons/duotone-icons/Map/Direction#1.svg": 646,
	"./icons/duotone-icons/Map/Direction#2": 647,
	"./icons/duotone-icons/Map/Direction#2.svg": 647,
	"./icons/duotone-icons/Map/Location-arrow": 648,
	"./icons/duotone-icons/Map/Location-arrow.svg": 648,
	"./icons/duotone-icons/Map/Marker#1": 649,
	"./icons/duotone-icons/Map/Marker#1.svg": 649,
	"./icons/duotone-icons/Map/Marker#2": 650,
	"./icons/duotone-icons/Map/Marker#2.svg": 650,
	"./icons/duotone-icons/Map/Position": 651,
	"./icons/duotone-icons/Map/Position.svg": 651,
	"./icons/duotone-icons/Media/Add-music": 652,
	"./icons/duotone-icons/Media/Add-music.svg": 652,
	"./icons/duotone-icons/Media/Airplay": 653,
	"./icons/duotone-icons/Media/Airplay-video": 654,
	"./icons/duotone-icons/Media/Airplay-video.svg": 654,
	"./icons/duotone-icons/Media/Airplay.svg": 653,
	"./icons/duotone-icons/Media/Back": 655,
	"./icons/duotone-icons/Media/Back.svg": 655,
	"./icons/duotone-icons/Media/Backward": 656,
	"./icons/duotone-icons/Media/Backward.svg": 656,
	"./icons/duotone-icons/Media/CD": 657,
	"./icons/duotone-icons/Media/CD.svg": 657,
	"./icons/duotone-icons/Media/DVD": 658,
	"./icons/duotone-icons/Media/DVD.svg": 658,
	"./icons/duotone-icons/Media/Eject": 659,
	"./icons/duotone-icons/Media/Eject.svg": 659,
	"./icons/duotone-icons/Media/Equalizer": 660,
	"./icons/duotone-icons/Media/Equalizer.svg": 660,
	"./icons/duotone-icons/Media/Forward": 661,
	"./icons/duotone-icons/Media/Forward.svg": 661,
	"./icons/duotone-icons/Media/Media-library#1": 662,
	"./icons/duotone-icons/Media/Media-library#1.svg": 662,
	"./icons/duotone-icons/Media/Media-library#2": 663,
	"./icons/duotone-icons/Media/Media-library#2.svg": 663,
	"./icons/duotone-icons/Media/Media-library#3": 664,
	"./icons/duotone-icons/Media/Media-library#3.svg": 664,
	"./icons/duotone-icons/Media/Movie-Lane #2": 665,
	"./icons/duotone-icons/Media/Movie-Lane #2.svg": 665,
	"./icons/duotone-icons/Media/Movie-lane#1": 666,
	"./icons/duotone-icons/Media/Movie-lane#1.svg": 666,
	"./icons/duotone-icons/Media/Music": 667,
	"./icons/duotone-icons/Media/Music-cloud": 668,
	"./icons/duotone-icons/Media/Music-cloud.svg": 668,
	"./icons/duotone-icons/Media/Music-note": 669,
	"./icons/duotone-icons/Media/Music-note.svg": 669,
	"./icons/duotone-icons/Media/Music.svg": 667,
	"./icons/duotone-icons/Media/Mute": 670,
	"./icons/duotone-icons/Media/Mute.svg": 670,
	"./icons/duotone-icons/Media/Next": 671,
	"./icons/duotone-icons/Media/Next.svg": 671,
	"./icons/duotone-icons/Media/Pause": 672,
	"./icons/duotone-icons/Media/Pause.svg": 672,
	"./icons/duotone-icons/Media/Play": 673,
	"./icons/duotone-icons/Media/Play.svg": 673,
	"./icons/duotone-icons/Media/Playlist#1": 674,
	"./icons/duotone-icons/Media/Playlist#1.svg": 674,
	"./icons/duotone-icons/Media/Playlist#2": 675,
	"./icons/duotone-icons/Media/Playlist#2.svg": 675,
	"./icons/duotone-icons/Media/Rec": 676,
	"./icons/duotone-icons/Media/Rec.svg": 676,
	"./icons/duotone-icons/Media/Repeat": 677,
	"./icons/duotone-icons/Media/Repeat-one": 678,
	"./icons/duotone-icons/Media/Repeat-one.svg": 678,
	"./icons/duotone-icons/Media/Repeat.svg": 677,
	"./icons/duotone-icons/Media/Shuffle": 679,
	"./icons/duotone-icons/Media/Shuffle.svg": 679,
	"./icons/duotone-icons/Media/Volume-down": 680,
	"./icons/duotone-icons/Media/Volume-down.svg": 680,
	"./icons/duotone-icons/Media/Volume-full": 681,
	"./icons/duotone-icons/Media/Volume-full.svg": 681,
	"./icons/duotone-icons/Media/Volume-half": 682,
	"./icons/duotone-icons/Media/Volume-half.svg": 682,
	"./icons/duotone-icons/Media/Volume-up": 683,
	"./icons/duotone-icons/Media/Volume-up.svg": 683,
	"./icons/duotone-icons/Media/Vynil": 684,
	"./icons/duotone-icons/Media/Vynil.svg": 684,
	"./icons/duotone-icons/Media/Youtube": 685,
	"./icons/duotone-icons/Media/Youtube.svg": 685,
	"./icons/duotone-icons/Navigation/Angle-double-down": 686,
	"./icons/duotone-icons/Navigation/Angle-double-down.svg": 686,
	"./icons/duotone-icons/Navigation/Angle-double-left": 687,
	"./icons/duotone-icons/Navigation/Angle-double-left.svg": 687,
	"./icons/duotone-icons/Navigation/Angle-double-right": 688,
	"./icons/duotone-icons/Navigation/Angle-double-right.svg": 688,
	"./icons/duotone-icons/Navigation/Angle-double-up": 689,
	"./icons/duotone-icons/Navigation/Angle-double-up.svg": 689,
	"./icons/duotone-icons/Navigation/Angle-down": 690,
	"./icons/duotone-icons/Navigation/Angle-down.svg": 690,
	"./icons/duotone-icons/Navigation/Angle-left": 691,
	"./icons/duotone-icons/Navigation/Angle-left.svg": 691,
	"./icons/duotone-icons/Navigation/Angle-right": 692,
	"./icons/duotone-icons/Navigation/Angle-right.svg": 692,
	"./icons/duotone-icons/Navigation/Angle-up": 693,
	"./icons/duotone-icons/Navigation/Angle-up.svg": 693,
	"./icons/duotone-icons/Navigation/Arrow-down": 694,
	"./icons/duotone-icons/Navigation/Arrow-down.svg": 694,
	"./icons/duotone-icons/Navigation/Arrow-from-bottom": 695,
	"./icons/duotone-icons/Navigation/Arrow-from-bottom.svg": 695,
	"./icons/duotone-icons/Navigation/Arrow-from-left": 696,
	"./icons/duotone-icons/Navigation/Arrow-from-left.svg": 696,
	"./icons/duotone-icons/Navigation/Arrow-from-right": 697,
	"./icons/duotone-icons/Navigation/Arrow-from-right.svg": 697,
	"./icons/duotone-icons/Navigation/Arrow-from-top": 698,
	"./icons/duotone-icons/Navigation/Arrow-from-top.svg": 698,
	"./icons/duotone-icons/Navigation/Arrow-left": 699,
	"./icons/duotone-icons/Navigation/Arrow-left.svg": 699,
	"./icons/duotone-icons/Navigation/Arrow-right": 700,
	"./icons/duotone-icons/Navigation/Arrow-right.svg": 700,
	"./icons/duotone-icons/Navigation/Arrow-to-bottom": 701,
	"./icons/duotone-icons/Navigation/Arrow-to-bottom.svg": 701,
	"./icons/duotone-icons/Navigation/Arrow-to-left": 702,
	"./icons/duotone-icons/Navigation/Arrow-to-left.svg": 702,
	"./icons/duotone-icons/Navigation/Arrow-to-right": 703,
	"./icons/duotone-icons/Navigation/Arrow-to-right.svg": 703,
	"./icons/duotone-icons/Navigation/Arrow-to-up": 704,
	"./icons/duotone-icons/Navigation/Arrow-to-up.svg": 704,
	"./icons/duotone-icons/Navigation/Arrow-up": 705,
	"./icons/duotone-icons/Navigation/Arrow-up.svg": 705,
	"./icons/duotone-icons/Navigation/Arrows-h": 706,
	"./icons/duotone-icons/Navigation/Arrows-h.svg": 706,
	"./icons/duotone-icons/Navigation/Arrows-v": 707,
	"./icons/duotone-icons/Navigation/Arrows-v.svg": 707,
	"./icons/duotone-icons/Navigation/Check": 708,
	"./icons/duotone-icons/Navigation/Check.svg": 708,
	"./icons/duotone-icons/Navigation/Close": 709,
	"./icons/duotone-icons/Navigation/Close.svg": 709,
	"./icons/duotone-icons/Navigation/Double-check": 710,
	"./icons/duotone-icons/Navigation/Double-check.svg": 710,
	"./icons/duotone-icons/Navigation/Down-2": 711,
	"./icons/duotone-icons/Navigation/Down-2.svg": 711,
	"./icons/duotone-icons/Navigation/Down-left": 712,
	"./icons/duotone-icons/Navigation/Down-left.svg": 712,
	"./icons/duotone-icons/Navigation/Down-right": 713,
	"./icons/duotone-icons/Navigation/Down-right.svg": 713,
	"./icons/duotone-icons/Navigation/Exchange": 714,
	"./icons/duotone-icons/Navigation/Exchange.svg": 714,
	"./icons/duotone-icons/Navigation/Left 3": 715,
	"./icons/duotone-icons/Navigation/Left 3.svg": 715,
	"./icons/duotone-icons/Navigation/Left-2": 716,
	"./icons/duotone-icons/Navigation/Left-2.svg": 716,
	"./icons/duotone-icons/Navigation/Minus": 717,
	"./icons/duotone-icons/Navigation/Minus.svg": 717,
	"./icons/duotone-icons/Navigation/Plus": 718,
	"./icons/duotone-icons/Navigation/Plus.svg": 718,
	"./icons/duotone-icons/Navigation/Right 3": 719,
	"./icons/duotone-icons/Navigation/Right 3.svg": 719,
	"./icons/duotone-icons/Navigation/Right-2": 720,
	"./icons/duotone-icons/Navigation/Right-2.svg": 720,
	"./icons/duotone-icons/Navigation/Route": 721,
	"./icons/duotone-icons/Navigation/Route.svg": 721,
	"./icons/duotone-icons/Navigation/Sign-in": 722,
	"./icons/duotone-icons/Navigation/Sign-in.svg": 722,
	"./icons/duotone-icons/Navigation/Sign-out": 723,
	"./icons/duotone-icons/Navigation/Sign-out.svg": 723,
	"./icons/duotone-icons/Navigation/Up-2": 724,
	"./icons/duotone-icons/Navigation/Up-2.svg": 724,
	"./icons/duotone-icons/Navigation/Up-down": 725,
	"./icons/duotone-icons/Navigation/Up-down.svg": 725,
	"./icons/duotone-icons/Navigation/Up-left": 726,
	"./icons/duotone-icons/Navigation/Up-left.svg": 726,
	"./icons/duotone-icons/Navigation/Up-right": 727,
	"./icons/duotone-icons/Navigation/Up-right.svg": 727,
	"./icons/duotone-icons/Navigation/Waiting": 728,
	"./icons/duotone-icons/Navigation/Waiting.svg": 728,
	"./icons/duotone-icons/Shopping/ATM": 729,
	"./icons/duotone-icons/Shopping/ATM.svg": 729,
	"./icons/duotone-icons/Shopping/Bag#1": 730,
	"./icons/duotone-icons/Shopping/Bag#1.svg": 730,
	"./icons/duotone-icons/Shopping/Bag#2": 731,
	"./icons/duotone-icons/Shopping/Bag#2.svg": 731,
	"./icons/duotone-icons/Shopping/Barcode": 732,
	"./icons/duotone-icons/Shopping/Barcode-read": 733,
	"./icons/duotone-icons/Shopping/Barcode-read.svg": 733,
	"./icons/duotone-icons/Shopping/Barcode-scan": 734,
	"./icons/duotone-icons/Shopping/Barcode-scan.svg": 734,
	"./icons/duotone-icons/Shopping/Barcode.svg": 732,
	"./icons/duotone-icons/Shopping/Bitcoin": 735,
	"./icons/duotone-icons/Shopping/Bitcoin.svg": 735,
	"./icons/duotone-icons/Shopping/Box#1": 736,
	"./icons/duotone-icons/Shopping/Box#1.svg": 736,
	"./icons/duotone-icons/Shopping/Box#2": 737,
	"./icons/duotone-icons/Shopping/Box#2.svg": 737,
	"./icons/duotone-icons/Shopping/Box#3": 738,
	"./icons/duotone-icons/Shopping/Box#3.svg": 738,
	"./icons/duotone-icons/Shopping/Calculator": 739,
	"./icons/duotone-icons/Shopping/Calculator.svg": 739,
	"./icons/duotone-icons/Shopping/Cart#1": 740,
	"./icons/duotone-icons/Shopping/Cart#1.svg": 740,
	"./icons/duotone-icons/Shopping/Cart#2": 741,
	"./icons/duotone-icons/Shopping/Cart#2.svg": 741,
	"./icons/duotone-icons/Shopping/Cart#3": 742,
	"./icons/duotone-icons/Shopping/Cart#3.svg": 742,
	"./icons/duotone-icons/Shopping/Chart-bar#1": 743,
	"./icons/duotone-icons/Shopping/Chart-bar#1.svg": 743,
	"./icons/duotone-icons/Shopping/Chart-bar#2": 744,
	"./icons/duotone-icons/Shopping/Chart-bar#2.svg": 744,
	"./icons/duotone-icons/Shopping/Chart-bar#3": 745,
	"./icons/duotone-icons/Shopping/Chart-bar#3.svg": 745,
	"./icons/duotone-icons/Shopping/Chart-line#1": 746,
	"./icons/duotone-icons/Shopping/Chart-line#1.svg": 746,
	"./icons/duotone-icons/Shopping/Chart-line#2": 747,
	"./icons/duotone-icons/Shopping/Chart-line#2.svg": 747,
	"./icons/duotone-icons/Shopping/Chart-pie": 748,
	"./icons/duotone-icons/Shopping/Chart-pie.svg": 748,
	"./icons/duotone-icons/Shopping/Credit-card": 749,
	"./icons/duotone-icons/Shopping/Credit-card.svg": 749,
	"./icons/duotone-icons/Shopping/Dollar": 750,
	"./icons/duotone-icons/Shopping/Dollar.svg": 750,
	"./icons/duotone-icons/Shopping/Euro": 751,
	"./icons/duotone-icons/Shopping/Euro.svg": 751,
	"./icons/duotone-icons/Shopping/Gift": 752,
	"./icons/duotone-icons/Shopping/Gift.svg": 752,
	"./icons/duotone-icons/Shopping/Loader": 753,
	"./icons/duotone-icons/Shopping/Loader.svg": 753,
	"./icons/duotone-icons/Shopping/MC": 754,
	"./icons/duotone-icons/Shopping/MC.svg": 754,
	"./icons/duotone-icons/Shopping/Money": 755,
	"./icons/duotone-icons/Shopping/Money.svg": 755,
	"./icons/duotone-icons/Shopping/Pound": 756,
	"./icons/duotone-icons/Shopping/Pound.svg": 756,
	"./icons/duotone-icons/Shopping/Price #1": 757,
	"./icons/duotone-icons/Shopping/Price #1.svg": 757,
	"./icons/duotone-icons/Shopping/Price #2": 758,
	"./icons/duotone-icons/Shopping/Price #2.svg": 758,
	"./icons/duotone-icons/Shopping/Rouble": 759,
	"./icons/duotone-icons/Shopping/Rouble.svg": 759,
	"./icons/duotone-icons/Shopping/Safe": 760,
	"./icons/duotone-icons/Shopping/Safe.svg": 760,
	"./icons/duotone-icons/Shopping/Sale#1": 761,
	"./icons/duotone-icons/Shopping/Sale#1.svg": 761,
	"./icons/duotone-icons/Shopping/Sale#2": 762,
	"./icons/duotone-icons/Shopping/Sale#2.svg": 762,
	"./icons/duotone-icons/Shopping/Settings": 763,
	"./icons/duotone-icons/Shopping/Settings.svg": 763,
	"./icons/duotone-icons/Shopping/Sort#1": 764,
	"./icons/duotone-icons/Shopping/Sort#1.svg": 764,
	"./icons/duotone-icons/Shopping/Sort#2": 765,
	"./icons/duotone-icons/Shopping/Sort#2.svg": 765,
	"./icons/duotone-icons/Shopping/Sort#3": 766,
	"./icons/duotone-icons/Shopping/Sort#3.svg": 766,
	"./icons/duotone-icons/Shopping/Ticket": 767,
	"./icons/duotone-icons/Shopping/Ticket.svg": 767,
	"./icons/duotone-icons/Shopping/Wallet": 768,
	"./icons/duotone-icons/Shopping/Wallet#2": 769,
	"./icons/duotone-icons/Shopping/Wallet#2.svg": 769,
	"./icons/duotone-icons/Shopping/Wallet#3": 770,
	"./icons/duotone-icons/Shopping/Wallet#3.svg": 770,
	"./icons/duotone-icons/Shopping/Wallet.svg": 768,
	"./icons/duotone-icons/Text/Align-auto": 771,
	"./icons/duotone-icons/Text/Align-auto.svg": 771,
	"./icons/duotone-icons/Text/Align-center": 772,
	"./icons/duotone-icons/Text/Align-center.svg": 772,
	"./icons/duotone-icons/Text/Align-justify": 773,
	"./icons/duotone-icons/Text/Align-justify.svg": 773,
	"./icons/duotone-icons/Text/Align-left": 774,
	"./icons/duotone-icons/Text/Align-left.svg": 774,
	"./icons/duotone-icons/Text/Align-right": 775,
	"./icons/duotone-icons/Text/Align-right.svg": 775,
	"./icons/duotone-icons/Text/Article": 776,
	"./icons/duotone-icons/Text/Article.svg": 776,
	"./icons/duotone-icons/Text/Bold": 777,
	"./icons/duotone-icons/Text/Bold.svg": 777,
	"./icons/duotone-icons/Text/Bullet-list": 778,
	"./icons/duotone-icons/Text/Bullet-list.svg": 778,
	"./icons/duotone-icons/Text/Code": 779,
	"./icons/duotone-icons/Text/Code.svg": 779,
	"./icons/duotone-icons/Text/Edit-text": 780,
	"./icons/duotone-icons/Text/Edit-text.svg": 780,
	"./icons/duotone-icons/Text/Filter": 781,
	"./icons/duotone-icons/Text/Filter.svg": 781,
	"./icons/duotone-icons/Text/Font": 782,
	"./icons/duotone-icons/Text/Font.svg": 782,
	"./icons/duotone-icons/Text/H1": 783,
	"./icons/duotone-icons/Text/H1.svg": 783,
	"./icons/duotone-icons/Text/H2": 784,
	"./icons/duotone-icons/Text/H2.svg": 784,
	"./icons/duotone-icons/Text/Itallic": 785,
	"./icons/duotone-icons/Text/Itallic.svg": 785,
	"./icons/duotone-icons/Text/Menu": 786,
	"./icons/duotone-icons/Text/Menu.svg": 786,
	"./icons/duotone-icons/Text/Paragraph": 787,
	"./icons/duotone-icons/Text/Paragraph.svg": 787,
	"./icons/duotone-icons/Text/Quote#1": 788,
	"./icons/duotone-icons/Text/Quote#1.svg": 788,
	"./icons/duotone-icons/Text/Quote#2": 789,
	"./icons/duotone-icons/Text/Quote#2.svg": 789,
	"./icons/duotone-icons/Text/Redo": 790,
	"./icons/duotone-icons/Text/Redo.svg": 790,
	"./icons/duotone-icons/Text/Strikethrough": 791,
	"./icons/duotone-icons/Text/Strikethrough.svg": 791,
	"./icons/duotone-icons/Text/Text": 792,
	"./icons/duotone-icons/Text/Text-height": 793,
	"./icons/duotone-icons/Text/Text-height.svg": 793,
	"./icons/duotone-icons/Text/Text-width": 794,
	"./icons/duotone-icons/Text/Text-width.svg": 794,
	"./icons/duotone-icons/Text/Text.svg": 792,
	"./icons/duotone-icons/Text/Underline": 795,
	"./icons/duotone-icons/Text/Underline.svg": 795,
	"./icons/duotone-icons/Text/Undo": 796,
	"./icons/duotone-icons/Text/Undo.svg": 796,
	"./icons/duotone-icons/Tools/Angle Grinder": 797,
	"./icons/duotone-icons/Tools/Angle Grinder.svg": 797,
	"./icons/duotone-icons/Tools/Axe": 798,
	"./icons/duotone-icons/Tools/Axe.svg": 798,
	"./icons/duotone-icons/Tools/Brush": 799,
	"./icons/duotone-icons/Tools/Brush.svg": 799,
	"./icons/duotone-icons/Tools/Compass": 800,
	"./icons/duotone-icons/Tools/Compass.svg": 800,
	"./icons/duotone-icons/Tools/Hummer": 801,
	"./icons/duotone-icons/Tools/Hummer#2": 802,
	"./icons/duotone-icons/Tools/Hummer#2.svg": 802,
	"./icons/duotone-icons/Tools/Hummer.svg": 801,
	"./icons/duotone-icons/Tools/Pantone": 803,
	"./icons/duotone-icons/Tools/Pantone.svg": 803,
	"./icons/duotone-icons/Tools/Road-Cone": 804,
	"./icons/duotone-icons/Tools/Road-Cone.svg": 804,
	"./icons/duotone-icons/Tools/Roller": 805,
	"./icons/duotone-icons/Tools/Roller.svg": 805,
	"./icons/duotone-icons/Tools/Roulette": 806,
	"./icons/duotone-icons/Tools/Roulette.svg": 806,
	"./icons/duotone-icons/Tools/Screwdriver": 807,
	"./icons/duotone-icons/Tools/Screwdriver.svg": 807,
	"./icons/duotone-icons/Tools/Shovel": 808,
	"./icons/duotone-icons/Tools/Shovel.svg": 808,
	"./icons/duotone-icons/Tools/Spatula": 809,
	"./icons/duotone-icons/Tools/Spatula.svg": 809,
	"./icons/duotone-icons/Tools/Swiss-knife": 810,
	"./icons/duotone-icons/Tools/Swiss-knife.svg": 810,
	"./icons/duotone-icons/Tools/Tools": 811,
	"./icons/duotone-icons/Tools/Tools.svg": 811,
	"./icons/duotone-icons/Weather/Celcium": 812,
	"./icons/duotone-icons/Weather/Celcium.svg": 812,
	"./icons/duotone-icons/Weather/Cloud#1": 813,
	"./icons/duotone-icons/Weather/Cloud#1.svg": 813,
	"./icons/duotone-icons/Weather/Cloud#2": 814,
	"./icons/duotone-icons/Weather/Cloud#2.svg": 814,
	"./icons/duotone-icons/Weather/Cloud-fog": 815,
	"./icons/duotone-icons/Weather/Cloud-fog.svg": 815,
	"./icons/duotone-icons/Weather/Cloud-sun": 816,
	"./icons/duotone-icons/Weather/Cloud-sun.svg": 816,
	"./icons/duotone-icons/Weather/Cloud-wind": 817,
	"./icons/duotone-icons/Weather/Cloud-wind.svg": 817,
	"./icons/duotone-icons/Weather/Cloudy": 818,
	"./icons/duotone-icons/Weather/Cloudy-night": 819,
	"./icons/duotone-icons/Weather/Cloudy-night.svg": 819,
	"./icons/duotone-icons/Weather/Cloudy.svg": 818,
	"./icons/duotone-icons/Weather/Day-rain": 820,
	"./icons/duotone-icons/Weather/Day-rain.svg": 820,
	"./icons/duotone-icons/Weather/Fahrenheit": 821,
	"./icons/duotone-icons/Weather/Fahrenheit.svg": 821,
	"./icons/duotone-icons/Weather/Fog": 822,
	"./icons/duotone-icons/Weather/Fog.svg": 822,
	"./icons/duotone-icons/Weather/Moon": 823,
	"./icons/duotone-icons/Weather/Moon.svg": 823,
	"./icons/duotone-icons/Weather/Night-fog": 824,
	"./icons/duotone-icons/Weather/Night-fog.svg": 824,
	"./icons/duotone-icons/Weather/Night-rain": 825,
	"./icons/duotone-icons/Weather/Night-rain.svg": 825,
	"./icons/duotone-icons/Weather/Rain#1": 826,
	"./icons/duotone-icons/Weather/Rain#1.svg": 826,
	"./icons/duotone-icons/Weather/Rain#2": 827,
	"./icons/duotone-icons/Weather/Rain#2.svg": 827,
	"./icons/duotone-icons/Weather/Rain#5": 828,
	"./icons/duotone-icons/Weather/Rain#5.svg": 828,
	"./icons/duotone-icons/Weather/Rainbow": 829,
	"./icons/duotone-icons/Weather/Rainbow.svg": 829,
	"./icons/duotone-icons/Weather/Snow": 830,
	"./icons/duotone-icons/Weather/Snow#1": 831,
	"./icons/duotone-icons/Weather/Snow#1.svg": 831,
	"./icons/duotone-icons/Weather/Snow#2": 832,
	"./icons/duotone-icons/Weather/Snow#2.svg": 832,
	"./icons/duotone-icons/Weather/Snow#3": 833,
	"./icons/duotone-icons/Weather/Snow#3.svg": 833,
	"./icons/duotone-icons/Weather/Snow.svg": 830,
	"./icons/duotone-icons/Weather/Storm": 834,
	"./icons/duotone-icons/Weather/Storm.svg": 834,
	"./icons/duotone-icons/Weather/Sun": 835,
	"./icons/duotone-icons/Weather/Sun-fog": 836,
	"./icons/duotone-icons/Weather/Sun-fog.svg": 836,
	"./icons/duotone-icons/Weather/Sun.svg": 835,
	"./icons/duotone-icons/Weather/Suset#1": 837,
	"./icons/duotone-icons/Weather/Suset#1.svg": 837,
	"./icons/duotone-icons/Weather/Suset#2": 838,
	"./icons/duotone-icons/Weather/Suset#2.svg": 838,
	"./icons/duotone-icons/Weather/Temperature-empty": 839,
	"./icons/duotone-icons/Weather/Temperature-empty.svg": 839,
	"./icons/duotone-icons/Weather/Temperature-full": 840,
	"./icons/duotone-icons/Weather/Temperature-full.svg": 840,
	"./icons/duotone-icons/Weather/Temperature-half": 841,
	"./icons/duotone-icons/Weather/Temperature-half.svg": 841,
	"./icons/duotone-icons/Weather/Thunder": 842,
	"./icons/duotone-icons/Weather/Thunder-night": 843,
	"./icons/duotone-icons/Weather/Thunder-night.svg": 843,
	"./icons/duotone-icons/Weather/Thunder.svg": 842,
	"./icons/duotone-icons/Weather/Umbrella": 844,
	"./icons/duotone-icons/Weather/Umbrella.svg": 844,
	"./icons/duotone-icons/Weather/Wind": 845,
	"./icons/duotone-icons/Weather/Wind.svg": 845,
	"./icons/payment-methods/alipay": 846,
	"./icons/payment-methods/alipay.svg": 846,
	"./icons/payment-methods/amex": 847,
	"./icons/payment-methods/amex.svg": 847,
	"./icons/payment-methods/default": 848,
	"./icons/payment-methods/default.svg": 848,
	"./icons/payment-methods/diners": 849,
	"./icons/payment-methods/diners.svg": 849,
	"./icons/payment-methods/discover": 850,
	"./icons/payment-methods/discover.svg": 850,
	"./icons/payment-methods/elo": 851,
	"./icons/payment-methods/elo.svg": 851,
	"./icons/payment-methods/hipercard": 852,
	"./icons/payment-methods/hipercard.svg": 852,
	"./icons/payment-methods/jcb": 853,
	"./icons/payment-methods/jcb.svg": 853,
	"./icons/payment-methods/maestro": 854,
	"./icons/payment-methods/maestro-old": 855,
	"./icons/payment-methods/maestro-old.svg": 855,
	"./icons/payment-methods/maestro.svg": 854,
	"./icons/payment-methods/mastercard": 856,
	"./icons/payment-methods/mastercard-old": 857,
	"./icons/payment-methods/mastercard-old.svg": 857,
	"./icons/payment-methods/mastercard.svg": 856,
	"./icons/payment-methods/paypal": 858,
	"./icons/payment-methods/paypal.svg": 858,
	"./icons/payment-methods/security-code": 859,
	"./icons/payment-methods/security-code.svg": 859,
	"./icons/payment-methods/unionpay": 860,
	"./icons/payment-methods/unionpay.svg": 860,
	"./icons/payment-methods/verve": 861,
	"./icons/payment-methods/verve.svg": 861,
	"./icons/payment-methods/visa": 862,
	"./icons/payment-methods/visa.svg": 862,
	"./icons/social/facebook": 863,
	"./icons/social/facebook.svg": 863,
	"./icons/social/instagram": 864,
	"./icons/social/instagram.svg": 864,
	"./icons/social/linkedin": 865,
	"./icons/social/linkedin.svg": 865,
	"./icons/social/pinterest": 866,
	"./icons/social/pinterest.svg": 866,
	"./icons/social/twitter": 867,
	"./icons/social/twitter.svg": 867,
	"./illustrations/illustration-1": 868,
	"./illustrations/illustration-1-cropped": 869,
	"./illustrations/illustration-1-cropped.png": 869,
	"./illustrations/illustration-1-dark": 870,
	"./illustrations/illustration-1-dark.png": 870,
	"./illustrations/illustration-1.png": 868,
	"./illustrations/illustration-2": 871,
	"./illustrations/illustration-2.png": 871,
	"./illustrations/illustration-3": 872,
	"./illustrations/illustration-3-cropped": 873,
	"./illustrations/illustration-3-cropped.png": 873,
	"./illustrations/illustration-3.png": 872,
	"./illustrations/illustration-4": 874,
	"./illustrations/illustration-4-cropped": 875,
	"./illustrations/illustration-4-cropped.png": 875,
	"./illustrations/illustration-4.png": 874,
	"./illustrations/illustration-5": 876,
	"./illustrations/illustration-5.png": 876,
	"./illustrations/illustration-6": 877,
	"./illustrations/illustration-6-cropped": 878,
	"./illustrations/illustration-6-cropped.png": 878,
	"./illustrations/illustration-6.png": 877,
	"./illustrations/illustration-7": 879,
	"./illustrations/illustration-7.png": 879,
	"./illustrations/illustration-8": 880,
	"./illustrations/illustration-8.png": 880,
	"./illustrations/illustration-9": 881,
	"./illustrations/illustration-9.png": 881,
	"./index": 97,
	"./index.js": 97,
	"./jcrop": 882,
	"./jcrop.gif": 882,
	"./job-bg": 883,
	"./job-bg.jpg": 883,
	"./loading": 884,
	"./loading.gif": 884,
	"./masks/avatar-group": 885,
	"./masks/avatar-group-hover": 886,
	"./masks/avatar-group-hover-last": 887,
	"./masks/avatar-group-hover-last.svg": 887,
	"./masks/avatar-group-hover.svg": 886,
	"./masks/avatar-group.svg": 885,
	"./masks/avatar-status": 888,
	"./masks/avatar-status.svg": 888,
	"./photos/photo-1": 889,
	"./photos/photo-1.jpg": 889,
	"./photos/photo-10": 890,
	"./photos/photo-10.jpg": 890,
	"./photos/photo-11": 891,
	"./photos/photo-11.jpg": 891,
	"./photos/photo-12": 892,
	"./photos/photo-12.jpg": 892,
	"./photos/photo-13": 893,
	"./photos/photo-13.jpg": 893,
	"./photos/photo-14": 894,
	"./photos/photo-14.jpg": 894,
	"./photos/photo-15": 895,
	"./photos/photo-15.jpg": 895,
	"./photos/photo-16": 896,
	"./photos/photo-16.jpg": 896,
	"./photos/photo-17": 897,
	"./photos/photo-17.jpg": 897,
	"./photos/photo-18": 898,
	"./photos/photo-18.jpg": 898,
	"./photos/photo-19": 899,
	"./photos/photo-19.jpg": 899,
	"./photos/photo-2": 900,
	"./photos/photo-2.jpg": 900,
	"./photos/photo-20": 901,
	"./photos/photo-20.jpg": 901,
	"./photos/photo-21": 902,
	"./photos/photo-21.jpg": 902,
	"./photos/photo-22": 903,
	"./photos/photo-22.jpg": 903,
	"./photos/photo-23": 904,
	"./photos/photo-23.jpg": 904,
	"./photos/photo-24": 905,
	"./photos/photo-24.jpg": 905,
	"./photos/photo-25": 906,
	"./photos/photo-25.jpg": 906,
	"./photos/photo-26": 907,
	"./photos/photo-26.jpg": 907,
	"./photos/photo-27": 908,
	"./photos/photo-27.jpg": 908,
	"./photos/photo-28": 909,
	"./photos/photo-28.jpg": 909,
	"./photos/photo-29": 910,
	"./photos/photo-29.jpg": 910,
	"./photos/photo-3": 911,
	"./photos/photo-3.jpg": 911,
	"./photos/photo-30": 912,
	"./photos/photo-30.jpg": 912,
	"./photos/photo-4": 913,
	"./photos/photo-4.jpg": 913,
	"./photos/photo-5": 914,
	"./photos/photo-5.jpg": 914,
	"./photos/photo-6": 915,
	"./photos/photo-6.jpg": 915,
	"./photos/photo-7": 916,
	"./photos/photo-7.jpg": 916,
	"./photos/photo-8": 917,
	"./photos/photo-8.jpg": 917,
	"./photos/photo-9": 918,
	"./photos/photo-9.jpg": 918,
	"./profile-missing": 919,
	"./profile-missing.svg": 919,
	"./shapes/angles/angle-bottom": 920,
	"./shapes/angles/angle-bottom.svg": 920,
	"./shapes/angles/angle-left": 921,
	"./shapes/angles/angle-left.svg": 921,
	"./shapes/angles/angle-right": 922,
	"./shapes/angles/angle-right.svg": 922,
	"./shapes/angles/angle-top": 923,
	"./shapes/angles/angle-top.svg": 923,
	"./shapes/blurs/blur-1": 924,
	"./shapes/blurs/blur-1.svg": 924,
	"./shapes/blurs/blur-2": 925,
	"./shapes/blurs/blur-2.svg": 925,
	"./shapes/blurs/blur-3": 926,
	"./shapes/blurs/blur-3.svg": 926,
	"./shapes/blurs/blur-4": 927,
	"./shapes/blurs/blur-4.svg": 927,
	"./shapes/curves/curve-1": 928,
	"./shapes/curves/curve-1.svg": 928,
	"./shapes/curves/curve-2": 929,
	"./shapes/curves/curve-2.svg": 929,
	"./shapes/curves/curve-3": 930,
	"./shapes/curves/curve-3.svg": 930,
	"./shapes/curves/curve-4": 931,
	"./shapes/curves/curve-4.svg": 931,
	"./shapes/curves/curve-5": 932,
	"./shapes/curves/curve-5.svg": 932,
	"./shapes/curves/curve-6": 933,
	"./shapes/curves/curve-6.svg": 933,
	"./shapes/waves/wave-1": 934,
	"./shapes/waves/wave-1.svg": 934,
	"./slack-logo": 935,
	"./slack-logo.jpg": 935,
	"./trix_color": 936,
	"./trix_color.svg": 936,
	"./trix_horizontal_rule": 937,
	"./trix_horizontal_rule.svg": 937,
	"./trix_image": 938,
	"./trix_image.svg": 938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1289;